(() => {
/**
 * Entry for the isolated `tune-consent.js` bundle, loaded by every Django
 * template (index.html, landing/index.html, base_embed.html). Built by
 * `yarn build:consent` into dist/tune-consent.js. The CSS is inlined into the
 * shadow root, so there is no separate stylesheet to link.
 */ let $44b2e6cc5a4c09f8$var$taskIdCounter = 1, $44b2e6cc5a4c09f8$var$isCallbackScheduled = false, $44b2e6cc5a4c09f8$var$isPerformingWork = false, $44b2e6cc5a4c09f8$var$taskQueue = [], $44b2e6cc5a4c09f8$var$currentTask = null, $44b2e6cc5a4c09f8$var$shouldYieldToHost = null, $44b2e6cc5a4c09f8$var$yieldInterval = 5, $44b2e6cc5a4c09f8$var$deadline = 0, $44b2e6cc5a4c09f8$var$maxYieldInterval = 300, $44b2e6cc5a4c09f8$var$scheduleCallback = null, $44b2e6cc5a4c09f8$var$scheduledCallback = null;
const $44b2e6cc5a4c09f8$var$maxSigned31BitInt = 1073741823;
function $44b2e6cc5a4c09f8$var$setupScheduler() {
    const channel = new MessageChannel(), port = channel.port2;
    $44b2e6cc5a4c09f8$var$scheduleCallback = ()=>port.postMessage(null);
    channel.port1.onmessage = ()=>{
        if ($44b2e6cc5a4c09f8$var$scheduledCallback !== null) {
            const currentTime = performance.now();
            $44b2e6cc5a4c09f8$var$deadline = currentTime + $44b2e6cc5a4c09f8$var$yieldInterval;
            const hasTimeRemaining = true;
            try {
                const hasMoreWork = $44b2e6cc5a4c09f8$var$scheduledCallback(hasTimeRemaining, currentTime);
                if (!hasMoreWork) $44b2e6cc5a4c09f8$var$scheduledCallback = null;
                else port.postMessage(null);
            } catch (error) {
                port.postMessage(null);
                throw error;
            }
        }
    };
    if (navigator && navigator.scheduling && navigator.scheduling.isInputPending) {
        const scheduling = navigator.scheduling;
        $44b2e6cc5a4c09f8$var$shouldYieldToHost = ()=>{
            const currentTime = performance.now();
            if (currentTime >= $44b2e6cc5a4c09f8$var$deadline) {
                if (scheduling.isInputPending()) return true;
                return currentTime >= $44b2e6cc5a4c09f8$var$maxYieldInterval;
            } else return false;
        };
    } else $44b2e6cc5a4c09f8$var$shouldYieldToHost = ()=>performance.now() >= $44b2e6cc5a4c09f8$var$deadline;
}
function $44b2e6cc5a4c09f8$var$enqueue(taskQueue, task) {
    function findIndex() {
        let m = 0;
        let n = taskQueue.length - 1;
        while(m <= n){
            const k = n + m >> 1;
            const cmp = task.expirationTime - taskQueue[k].expirationTime;
            if (cmp > 0) m = k + 1;
            else if (cmp < 0) n = k - 1;
            else return k;
        }
        return m;
    }
    taskQueue.splice(findIndex(), 0, task);
}
function $44b2e6cc5a4c09f8$export$4b5e076b3a2fbe0a(fn, options) {
    if (!$44b2e6cc5a4c09f8$var$scheduleCallback) $44b2e6cc5a4c09f8$var$setupScheduler();
    let startTime = performance.now(), timeout = $44b2e6cc5a4c09f8$var$maxSigned31BitInt;
    if (options && options.timeout) timeout = options.timeout;
    const newTask = {
        id: $44b2e6cc5a4c09f8$var$taskIdCounter++,
        fn: fn,
        startTime: startTime,
        expirationTime: startTime + timeout
    };
    $44b2e6cc5a4c09f8$var$enqueue($44b2e6cc5a4c09f8$var$taskQueue, newTask);
    if (!$44b2e6cc5a4c09f8$var$isCallbackScheduled && !$44b2e6cc5a4c09f8$var$isPerformingWork) {
        $44b2e6cc5a4c09f8$var$isCallbackScheduled = true;
        $44b2e6cc5a4c09f8$var$scheduledCallback = $44b2e6cc5a4c09f8$var$flushWork;
        $44b2e6cc5a4c09f8$var$scheduleCallback();
    }
    return newTask;
}
function $44b2e6cc5a4c09f8$export$b888d8f981c07a46(task) {
    task.fn = null;
}
function $44b2e6cc5a4c09f8$var$flushWork(hasTimeRemaining, initialTime) {
    $44b2e6cc5a4c09f8$var$isCallbackScheduled = false;
    $44b2e6cc5a4c09f8$var$isPerformingWork = true;
    try {
        return $44b2e6cc5a4c09f8$var$workLoop(hasTimeRemaining, initialTime);
    } finally{
        $44b2e6cc5a4c09f8$var$currentTask = null;
        $44b2e6cc5a4c09f8$var$isPerformingWork = false;
    }
}
function $44b2e6cc5a4c09f8$var$workLoop(hasTimeRemaining, initialTime) {
    let currentTime = initialTime;
    $44b2e6cc5a4c09f8$var$currentTask = $44b2e6cc5a4c09f8$var$taskQueue[0] || null;
    while($44b2e6cc5a4c09f8$var$currentTask !== null){
        if ($44b2e6cc5a4c09f8$var$currentTask.expirationTime > currentTime && (!hasTimeRemaining || $44b2e6cc5a4c09f8$var$shouldYieldToHost())) break;
        const callback = $44b2e6cc5a4c09f8$var$currentTask.fn;
        if (callback !== null) {
            $44b2e6cc5a4c09f8$var$currentTask.fn = null;
            const didUserCallbackTimeout = $44b2e6cc5a4c09f8$var$currentTask.expirationTime <= currentTime;
            callback(didUserCallbackTimeout);
            currentTime = performance.now();
            if ($44b2e6cc5a4c09f8$var$currentTask === $44b2e6cc5a4c09f8$var$taskQueue[0]) $44b2e6cc5a4c09f8$var$taskQueue.shift();
        } else $44b2e6cc5a4c09f8$var$taskQueue.shift();
        $44b2e6cc5a4c09f8$var$currentTask = $44b2e6cc5a4c09f8$var$taskQueue[0] || null;
    }
    return $44b2e6cc5a4c09f8$var$currentTask !== null;
}
const $44b2e6cc5a4c09f8$export$2cb4986bed338027 = {
    context: undefined,
    registry: undefined,
    effects: undefined,
    done: false,
    getContextId () {
        return $44b2e6cc5a4c09f8$var$getContextId(this.context.count);
    },
    getNextContextId () {
        return $44b2e6cc5a4c09f8$var$getContextId(this.context.count++);
    }
};
function $44b2e6cc5a4c09f8$var$getContextId(count) {
    const num = String(count), len = num.length - 1;
    return $44b2e6cc5a4c09f8$export$2cb4986bed338027.context.id + (len ? String.fromCharCode(96 + len) : "") + num;
}
function $44b2e6cc5a4c09f8$var$setHydrateContext(context) {
    $44b2e6cc5a4c09f8$export$2cb4986bed338027.context = context;
}
function $44b2e6cc5a4c09f8$var$nextHydrateContext() {
    return {
        ...$44b2e6cc5a4c09f8$export$2cb4986bed338027.context,
        id: $44b2e6cc5a4c09f8$export$2cb4986bed338027.getNextContextId(),
        count: 0
    };
}
const $44b2e6cc5a4c09f8$var$IS_DEV = false;
const $44b2e6cc5a4c09f8$export$34b67c27f2ca7498 = (a, b)=>a === b;
const $44b2e6cc5a4c09f8$export$5cd89106e2f6c2c5 = Symbol("solid-proxy");
const $44b2e6cc5a4c09f8$var$SUPPORTS_PROXY = typeof Proxy === "function";
const $44b2e6cc5a4c09f8$export$17a675b7c02a7b1d = Symbol("solid-track");
const $44b2e6cc5a4c09f8$export$f5625ae0b78e5b20 = Symbol("solid-dev-component");
const $44b2e6cc5a4c09f8$var$signalOptions = {
    equals: $44b2e6cc5a4c09f8$export$34b67c27f2ca7498
};
let $44b2e6cc5a4c09f8$var$ERROR = null;
let $44b2e6cc5a4c09f8$var$runEffects = $44b2e6cc5a4c09f8$var$runQueue;
const $44b2e6cc5a4c09f8$var$STALE = 1;
const $44b2e6cc5a4c09f8$var$PENDING = 2;
const $44b2e6cc5a4c09f8$var$UNOWNED = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
const $44b2e6cc5a4c09f8$var$NO_INIT = {};
var $44b2e6cc5a4c09f8$var$Owner = null;
let $44b2e6cc5a4c09f8$var$Transition = null;
let $44b2e6cc5a4c09f8$var$Scheduler = null;
let $44b2e6cc5a4c09f8$var$ExternalSourceConfig = null;
let $44b2e6cc5a4c09f8$var$Listener = null;
let $44b2e6cc5a4c09f8$var$Updates = null;
let $44b2e6cc5a4c09f8$var$Effects = null;
let $44b2e6cc5a4c09f8$var$ExecCount = 0;
function $44b2e6cc5a4c09f8$export$882461b6382ed46c(fn, detachedOwner) {
    const listener = $44b2e6cc5a4c09f8$var$Listener, owner = $44b2e6cc5a4c09f8$var$Owner, unowned = fn.length === 0, current = detachedOwner === undefined ? owner : detachedOwner, root = unowned ? $44b2e6cc5a4c09f8$var$UNOWNED : {
        owned: null,
        cleanups: null,
        context: current ? current.context : null,
        owner: current
    }, updateFn = unowned ? fn : ()=>fn(()=>$44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>$44b2e6cc5a4c09f8$var$cleanNode(root)));
    $44b2e6cc5a4c09f8$var$Owner = root;
    $44b2e6cc5a4c09f8$var$Listener = null;
    try {
        return $44b2e6cc5a4c09f8$var$runUpdates(updateFn, true);
    } finally{
        $44b2e6cc5a4c09f8$var$Listener = listener;
        $44b2e6cc5a4c09f8$var$Owner = owner;
    }
}
function $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(value, options) {
    options = options ? Object.assign({}, $44b2e6cc5a4c09f8$var$signalOptions, options) : $44b2e6cc5a4c09f8$var$signalOptions;
    const s = {
        value: value,
        observers: null,
        observerSlots: null,
        comparator: options.equals || undefined
    };
    const setter = (value)=>{
        if (typeof value === "function") {
            if ($44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running && $44b2e6cc5a4c09f8$var$Transition.sources.has(s)) value = value(s.tValue);
            else value = value(s.value);
        }
        return $44b2e6cc5a4c09f8$var$writeSignal(s, value);
    };
    return [
        $44b2e6cc5a4c09f8$var$readSignal.bind(s),
        setter
    ];
}
function $44b2e6cc5a4c09f8$export$234a23cdc77e6a3d(fn, value, options) {
    const c = $44b2e6cc5a4c09f8$var$createComputation(fn, value, true, $44b2e6cc5a4c09f8$var$STALE);
    if ($44b2e6cc5a4c09f8$var$Scheduler && $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running) $44b2e6cc5a4c09f8$var$Updates.push(c);
    else $44b2e6cc5a4c09f8$var$updateComputation(c);
}
function $44b2e6cc5a4c09f8$export$314dade334ae905d(fn, value, options) {
    const c = $44b2e6cc5a4c09f8$var$createComputation(fn, value, false, $44b2e6cc5a4c09f8$var$STALE);
    if ($44b2e6cc5a4c09f8$var$Scheduler && $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running) $44b2e6cc5a4c09f8$var$Updates.push(c);
    else $44b2e6cc5a4c09f8$var$updateComputation(c);
}
function $44b2e6cc5a4c09f8$export$7ea7134f704deda4(fn, value, options) {
    $44b2e6cc5a4c09f8$var$runEffects = $44b2e6cc5a4c09f8$var$runUserEffects;
    const c = $44b2e6cc5a4c09f8$var$createComputation(fn, value, false, $44b2e6cc5a4c09f8$var$STALE), s = $44b2e6cc5a4c09f8$var$SuspenseContext && $44b2e6cc5a4c09f8$export$fae74005e78b1a27($44b2e6cc5a4c09f8$var$SuspenseContext);
    if (s) c.suspense = s;
    if (!options || !options.render) c.user = true;
    $44b2e6cc5a4c09f8$var$Effects ? $44b2e6cc5a4c09f8$var$Effects.push(c) : $44b2e6cc5a4c09f8$var$updateComputation(c);
}
function $44b2e6cc5a4c09f8$export$5ce14d95ebb45542(onInvalidate, options) {
    let fn;
    const c = $44b2e6cc5a4c09f8$var$createComputation(()=>{
        fn ? fn() : $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(onInvalidate);
        fn = undefined;
    }, undefined, false, 0), s = $44b2e6cc5a4c09f8$var$SuspenseContext && $44b2e6cc5a4c09f8$export$fae74005e78b1a27($44b2e6cc5a4c09f8$var$SuspenseContext);
    if (s) c.suspense = s;
    c.user = true;
    return (tracking)=>{
        fn = tracking;
        $44b2e6cc5a4c09f8$var$updateComputation(c);
    };
}
function $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(fn, value, options) {
    options = options ? Object.assign({}, $44b2e6cc5a4c09f8$var$signalOptions, options) : $44b2e6cc5a4c09f8$var$signalOptions;
    const c = $44b2e6cc5a4c09f8$var$createComputation(fn, value, true, 0);
    c.observers = null;
    c.observerSlots = null;
    c.comparator = options.equals || undefined;
    if ($44b2e6cc5a4c09f8$var$Scheduler && $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running) {
        c.tState = $44b2e6cc5a4c09f8$var$STALE;
        $44b2e6cc5a4c09f8$var$Updates.push(c);
    } else $44b2e6cc5a4c09f8$var$updateComputation(c);
    return $44b2e6cc5a4c09f8$var$readSignal.bind(c);
}
function $44b2e6cc5a4c09f8$var$isPromise(v) {
    return v && typeof v === "object" && "then" in v;
}
function $44b2e6cc5a4c09f8$export$edd172c6c83c39cc(pSource, pFetcher, pOptions) {
    let source;
    let fetcher;
    let options;
    if (typeof pFetcher === "function") {
        source = pSource;
        fetcher = pFetcher;
        options = pOptions || {};
    } else {
        source = true;
        fetcher = pSource;
        options = pFetcher || {};
    }
    let pr = null, initP = $44b2e6cc5a4c09f8$var$NO_INIT, id = null, loadedUnderTransition = false, scheduled = false, resolved = "initialValue" in options, dynamic = typeof source === "function" && $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(source);
    const contexts = new Set(), [value, setValue] = (options.storage || $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5)(options.initialValue), [error, setError] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(undefined), [track, trigger] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(undefined, {
        equals: false
    }), [state, setState] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(resolved ? "ready" : "unresolved");
    if ($44b2e6cc5a4c09f8$export$2cb4986bed338027.context) {
        id = $44b2e6cc5a4c09f8$export$2cb4986bed338027.getNextContextId();
        if (options.ssrLoadFrom === "initial") initP = options.initialValue;
        else if ($44b2e6cc5a4c09f8$export$2cb4986bed338027.load && $44b2e6cc5a4c09f8$export$2cb4986bed338027.has(id)) initP = $44b2e6cc5a4c09f8$export$2cb4986bed338027.load(id);
    }
    function loadEnd(p, v, error, key) {
        if (pr === p) {
            pr = null;
            key !== undefined && (resolved = true);
            if ((p === initP || v === initP) && options.onHydrated) queueMicrotask(()=>options.onHydrated(key, {
                    value: v
                }));
            initP = $44b2e6cc5a4c09f8$var$NO_INIT;
            if ($44b2e6cc5a4c09f8$var$Transition && p && loadedUnderTransition) {
                $44b2e6cc5a4c09f8$var$Transition.promises.delete(p);
                loadedUnderTransition = false;
                $44b2e6cc5a4c09f8$var$runUpdates(()=>{
                    $44b2e6cc5a4c09f8$var$Transition.running = true;
                    completeLoad(v, error);
                }, false);
            } else completeLoad(v, error);
        }
        return v;
    }
    function completeLoad(v, err) {
        $44b2e6cc5a4c09f8$var$runUpdates(()=>{
            if (err === undefined) setValue(()=>v);
            setState(err !== undefined ? "errored" : resolved ? "ready" : "unresolved");
            setError(err);
            for (const c of contexts.keys())c.decrement();
            contexts.clear();
        }, false);
    }
    function read() {
        const c = $44b2e6cc5a4c09f8$var$SuspenseContext && $44b2e6cc5a4c09f8$export$fae74005e78b1a27($44b2e6cc5a4c09f8$var$SuspenseContext), v = value(), err = error();
        if (err !== undefined && !pr) throw err;
        if ($44b2e6cc5a4c09f8$var$Listener && !$44b2e6cc5a4c09f8$var$Listener.user && c) $44b2e6cc5a4c09f8$export$234a23cdc77e6a3d(()=>{
            track();
            if (pr) {
                if (c.resolved && $44b2e6cc5a4c09f8$var$Transition && loadedUnderTransition) $44b2e6cc5a4c09f8$var$Transition.promises.add(pr);
                else if (!contexts.has(c)) {
                    c.increment();
                    contexts.add(c);
                }
            }
        });
        return v;
    }
    function load(refetching = true) {
        if (refetching !== false && scheduled) return;
        scheduled = false;
        const lookup = dynamic ? dynamic() : source;
        loadedUnderTransition = $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running;
        if (lookup == null || lookup === false) {
            loadEnd(pr, $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(value));
            return;
        }
        if ($44b2e6cc5a4c09f8$var$Transition && pr) $44b2e6cc5a4c09f8$var$Transition.promises.delete(pr);
        let error;
        const p = initP !== $44b2e6cc5a4c09f8$var$NO_INIT ? initP : $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>{
            try {
                return fetcher(lookup, {
                    value: value(),
                    refetching: refetching
                });
            } catch (fetcherError) {
                error = fetcherError;
            }
        });
        if (error !== undefined) {
            loadEnd(pr, undefined, $44b2e6cc5a4c09f8$var$castError(error), lookup);
            return;
        } else if (!$44b2e6cc5a4c09f8$var$isPromise(p)) {
            loadEnd(pr, p, undefined, lookup);
            return p;
        }
        pr = p;
        if ("v" in p) {
            if (p.s === 1) loadEnd(pr, p.v, undefined, lookup);
            else loadEnd(pr, undefined, $44b2e6cc5a4c09f8$var$castError(p.v), lookup);
            return p;
        }
        scheduled = true;
        queueMicrotask(()=>scheduled = false);
        $44b2e6cc5a4c09f8$var$runUpdates(()=>{
            setState(resolved ? "refreshing" : "pending");
            trigger();
        }, false);
        return p.then((v)=>loadEnd(p, v, undefined, lookup), (e)=>loadEnd(p, undefined, $44b2e6cc5a4c09f8$var$castError(e), lookup));
    }
    Object.defineProperties(read, {
        state: {
            get: ()=>state()
        },
        error: {
            get: ()=>error()
        },
        loading: {
            get () {
                const s = state();
                return s === "pending" || s === "refreshing";
            }
        },
        latest: {
            get () {
                if (!resolved) return read();
                const err = error();
                if (err && !pr) throw err;
                return value();
            }
        }
    });
    let owner = $44b2e6cc5a4c09f8$var$Owner;
    if (dynamic) $44b2e6cc5a4c09f8$export$234a23cdc77e6a3d(()=>(owner = $44b2e6cc5a4c09f8$var$Owner, load(false)));
    else load(false);
    return [
        read,
        {
            refetch: (info)=>$44b2e6cc5a4c09f8$export$c14f3e3abbc7d6b5(owner, ()=>load(info)),
            mutate: setValue
        }
    ];
}
function $44b2e6cc5a4c09f8$export$e673efccd97e4223(source, options) {
    let t, timeout = options ? options.timeoutMs : undefined;
    const node = $44b2e6cc5a4c09f8$var$createComputation(()=>{
        if (!t || !t.fn) t = $44b2e6cc5a4c09f8$export$4b5e076b3a2fbe0a(()=>setDeferred(()=>node.value), timeout !== undefined ? {
            timeout: timeout
        } : undefined);
        return source();
    }, undefined, true);
    const [deferred, setDeferred] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5($44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running && $44b2e6cc5a4c09f8$var$Transition.sources.has(node) ? node.tValue : node.value, options);
    $44b2e6cc5a4c09f8$var$updateComputation(node);
    setDeferred(()=>$44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running && $44b2e6cc5a4c09f8$var$Transition.sources.has(node) ? node.tValue : node.value);
    return deferred;
}
function $44b2e6cc5a4c09f8$export$595d22ed68ca2841(source, fn = $44b2e6cc5a4c09f8$export$34b67c27f2ca7498, options) {
    const subs = new Map();
    const node = $44b2e6cc5a4c09f8$var$createComputation((p)=>{
        const v = source();
        for (const [key, val] of subs.entries())if (fn(key, v) !== fn(key, p)) for (const c of val.values()){
            c.state = $44b2e6cc5a4c09f8$var$STALE;
            if (c.pure) $44b2e6cc5a4c09f8$var$Updates.push(c);
            else $44b2e6cc5a4c09f8$var$Effects.push(c);
        }
        return v;
    }, undefined, true, $44b2e6cc5a4c09f8$var$STALE);
    $44b2e6cc5a4c09f8$var$updateComputation(node);
    return (key)=>{
        const listener = $44b2e6cc5a4c09f8$var$Listener;
        if (listener) {
            let l;
            if (l = subs.get(key)) l.add(listener);
            else subs.set(key, l = new Set([
                listener
            ]));
            $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab(()=>{
                l.delete(listener);
                !l.size && subs.delete(key);
            });
        }
        return fn(key, $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running && $44b2e6cc5a4c09f8$var$Transition.sources.has(node) ? node.tValue : node.value);
    };
}
function $44b2e6cc5a4c09f8$export$712ea50be43a7858(fn) {
    return $44b2e6cc5a4c09f8$var$runUpdates(fn, false);
}
function $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(fn) {
    if (!$44b2e6cc5a4c09f8$var$ExternalSourceConfig && $44b2e6cc5a4c09f8$var$Listener === null) return fn();
    const listener = $44b2e6cc5a4c09f8$var$Listener;
    $44b2e6cc5a4c09f8$var$Listener = null;
    try {
        if ($44b2e6cc5a4c09f8$var$ExternalSourceConfig) return $44b2e6cc5a4c09f8$var$ExternalSourceConfig.untrack(fn);
        return fn();
    } finally{
        $44b2e6cc5a4c09f8$var$Listener = listener;
    }
}
function $44b2e6cc5a4c09f8$export$af631764ddc44097(deps, fn, options) {
    const isArray = Array.isArray(deps);
    let prevInput;
    let defer = options && options.defer;
    return (prevValue)=>{
        let input;
        if (isArray) {
            input = Array(deps.length);
            for(let i = 0; i < deps.length; i++)input[i] = deps[i]();
        } else input = deps();
        if (defer) {
            defer = false;
            return prevValue;
        }
        const result = $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>fn(input, prevInput, prevValue));
        prevInput = input;
        return result;
    };
}
function $44b2e6cc5a4c09f8$export$1e848a9e87980bd5(fn) {
    $44b2e6cc5a4c09f8$export$7ea7134f704deda4(()=>$44b2e6cc5a4c09f8$export$363ebc4b78b8f807(fn));
}
function $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab(fn) {
    if ($44b2e6cc5a4c09f8$var$Owner === null) ;
    else if ($44b2e6cc5a4c09f8$var$Owner.cleanups === null) $44b2e6cc5a4c09f8$var$Owner.cleanups = [
        fn
    ];
    else $44b2e6cc5a4c09f8$var$Owner.cleanups.push(fn);
    return fn;
}
function $44b2e6cc5a4c09f8$export$3dede90624df3ba9(fn, handler) {
    $44b2e6cc5a4c09f8$var$ERROR || ($44b2e6cc5a4c09f8$var$ERROR = Symbol("error"));
    $44b2e6cc5a4c09f8$var$Owner = $44b2e6cc5a4c09f8$var$createComputation(undefined, undefined, true);
    $44b2e6cc5a4c09f8$var$Owner.context = {
        ...$44b2e6cc5a4c09f8$var$Owner.context,
        [$44b2e6cc5a4c09f8$var$ERROR]: [
            handler
        ]
    };
    if ($44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running) $44b2e6cc5a4c09f8$var$Transition.sources.add($44b2e6cc5a4c09f8$var$Owner);
    try {
        return fn();
    } catch (err) {
        $44b2e6cc5a4c09f8$var$handleError(err);
    } finally{
        $44b2e6cc5a4c09f8$var$Owner = $44b2e6cc5a4c09f8$var$Owner.owner;
    }
}
function $44b2e6cc5a4c09f8$export$12abb5141c6fdc9c() {
    return $44b2e6cc5a4c09f8$var$Listener;
}
function $44b2e6cc5a4c09f8$export$5f4ed0d56c2c0edf() {
    return $44b2e6cc5a4c09f8$var$Owner;
}
function $44b2e6cc5a4c09f8$export$c14f3e3abbc7d6b5(o, fn) {
    const prev = $44b2e6cc5a4c09f8$var$Owner;
    const prevListener = $44b2e6cc5a4c09f8$var$Listener;
    $44b2e6cc5a4c09f8$var$Owner = o;
    $44b2e6cc5a4c09f8$var$Listener = null;
    try {
        return $44b2e6cc5a4c09f8$var$runUpdates(fn, true);
    } catch (err) {
        $44b2e6cc5a4c09f8$var$handleError(err);
    } finally{
        $44b2e6cc5a4c09f8$var$Owner = prev;
        $44b2e6cc5a4c09f8$var$Listener = prevListener;
    }
}
function $44b2e6cc5a4c09f8$export$45e8540700504e87(scheduler = $44b2e6cc5a4c09f8$export$4b5e076b3a2fbe0a) {
    $44b2e6cc5a4c09f8$var$Scheduler = scheduler;
}
function $44b2e6cc5a4c09f8$export$7568632d0d33d16d(fn) {
    if ($44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running) {
        fn();
        return $44b2e6cc5a4c09f8$var$Transition.done;
    }
    const l = $44b2e6cc5a4c09f8$var$Listener;
    const o = $44b2e6cc5a4c09f8$var$Owner;
    return Promise.resolve().then(()=>{
        $44b2e6cc5a4c09f8$var$Listener = l;
        $44b2e6cc5a4c09f8$var$Owner = o;
        let t;
        if ($44b2e6cc5a4c09f8$var$Scheduler || $44b2e6cc5a4c09f8$var$SuspenseContext) {
            t = $44b2e6cc5a4c09f8$var$Transition || ($44b2e6cc5a4c09f8$var$Transition = {
                sources: new Set(),
                effects: [],
                promises: new Set(),
                disposed: new Set(),
                queue: new Set(),
                running: true
            });
            t.done || (t.done = new Promise((res)=>t.resolve = res));
            t.running = true;
        }
        $44b2e6cc5a4c09f8$var$runUpdates(fn, false);
        $44b2e6cc5a4c09f8$var$Listener = $44b2e6cc5a4c09f8$var$Owner = null;
        return t ? t.done : undefined;
    });
}
const [$44b2e6cc5a4c09f8$var$transPending, $44b2e6cc5a4c09f8$var$setTransPending] = /*@__PURE__*/ $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(false);
function $44b2e6cc5a4c09f8$export$7b286972b8d8ccbf() {
    return [
        $44b2e6cc5a4c09f8$var$transPending,
        $44b2e6cc5a4c09f8$export$7568632d0d33d16d
    ];
}
function $44b2e6cc5a4c09f8$var$resumeEffects(e) {
    $44b2e6cc5a4c09f8$var$Effects.push.apply($44b2e6cc5a4c09f8$var$Effects, e);
    e.length = 0;
}
function $44b2e6cc5a4c09f8$export$fd42f52fd3ae1109(defaultValue, options) {
    const id = Symbol("context");
    return {
        id: id,
        Provider: $44b2e6cc5a4c09f8$var$createProvider(id),
        defaultValue: defaultValue
    };
}
function $44b2e6cc5a4c09f8$export$fae74005e78b1a27(context) {
    let value;
    return $44b2e6cc5a4c09f8$var$Owner && $44b2e6cc5a4c09f8$var$Owner.context && (value = $44b2e6cc5a4c09f8$var$Owner.context[context.id]) !== undefined ? value : context.defaultValue;
}
function $44b2e6cc5a4c09f8$export$bacb5cc5a11aef16(fn) {
    const children = $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(fn);
    const memo = $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>$44b2e6cc5a4c09f8$var$resolveChildren(children()));
    memo.toArray = ()=>{
        const c = memo();
        return Array.isArray(c) ? c : c != null ? [
            c
        ] : [];
    };
    return memo;
}
let $44b2e6cc5a4c09f8$var$SuspenseContext;
function $44b2e6cc5a4c09f8$var$getSuspenseContext() {
    return $44b2e6cc5a4c09f8$var$SuspenseContext || ($44b2e6cc5a4c09f8$var$SuspenseContext = $44b2e6cc5a4c09f8$export$fd42f52fd3ae1109());
}
function $44b2e6cc5a4c09f8$export$315ab94ce87a624f(factory, untrack = (fn)=>fn()) {
    if ($44b2e6cc5a4c09f8$var$ExternalSourceConfig) {
        const { factory: oldFactory, untrack: oldUntrack } = $44b2e6cc5a4c09f8$var$ExternalSourceConfig;
        $44b2e6cc5a4c09f8$var$ExternalSourceConfig = {
            factory: (fn, trigger)=>{
                const oldSource = oldFactory(fn, trigger);
                const source = factory((x)=>oldSource.track(x), trigger);
                return {
                    track: (x)=>source.track(x),
                    dispose () {
                        source.dispose();
                        oldSource.dispose();
                    }
                };
            },
            untrack: (fn)=>oldUntrack(()=>untrack(fn))
        };
    } else $44b2e6cc5a4c09f8$var$ExternalSourceConfig = {
        factory: factory,
        untrack: untrack
    };
}
function $44b2e6cc5a4c09f8$var$readSignal() {
    const runningTransition = $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running;
    if (this.sources && (runningTransition ? this.tState : this.state)) {
        if ((runningTransition ? this.tState : this.state) === $44b2e6cc5a4c09f8$var$STALE) $44b2e6cc5a4c09f8$var$updateComputation(this);
        else {
            const updates = $44b2e6cc5a4c09f8$var$Updates;
            $44b2e6cc5a4c09f8$var$Updates = null;
            $44b2e6cc5a4c09f8$var$runUpdates(()=>$44b2e6cc5a4c09f8$var$lookUpstream(this), false);
            $44b2e6cc5a4c09f8$var$Updates = updates;
        }
    }
    if ($44b2e6cc5a4c09f8$var$Listener) {
        const sSlot = this.observers ? this.observers.length : 0;
        if (!$44b2e6cc5a4c09f8$var$Listener.sources) {
            $44b2e6cc5a4c09f8$var$Listener.sources = [
                this
            ];
            $44b2e6cc5a4c09f8$var$Listener.sourceSlots = [
                sSlot
            ];
        } else {
            $44b2e6cc5a4c09f8$var$Listener.sources.push(this);
            $44b2e6cc5a4c09f8$var$Listener.sourceSlots.push(sSlot);
        }
        if (!this.observers) {
            this.observers = [
                $44b2e6cc5a4c09f8$var$Listener
            ];
            this.observerSlots = [
                $44b2e6cc5a4c09f8$var$Listener.sources.length - 1
            ];
        } else {
            this.observers.push($44b2e6cc5a4c09f8$var$Listener);
            this.observerSlots.push($44b2e6cc5a4c09f8$var$Listener.sources.length - 1);
        }
    }
    if (runningTransition && $44b2e6cc5a4c09f8$var$Transition.sources.has(this)) return this.tValue;
    return this.value;
}
function $44b2e6cc5a4c09f8$var$writeSignal(node, value, isComp) {
    let current = $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running && $44b2e6cc5a4c09f8$var$Transition.sources.has(node) ? node.tValue : node.value;
    if (!node.comparator || !node.comparator(current, value)) {
        if ($44b2e6cc5a4c09f8$var$Transition) {
            const TransitionRunning = $44b2e6cc5a4c09f8$var$Transition.running;
            if (TransitionRunning || !isComp && $44b2e6cc5a4c09f8$var$Transition.sources.has(node)) {
                $44b2e6cc5a4c09f8$var$Transition.sources.add(node);
                node.tValue = value;
            }
            if (!TransitionRunning) node.value = value;
        } else node.value = value;
        if (node.observers && node.observers.length) $44b2e6cc5a4c09f8$var$runUpdates(()=>{
            for(let i = 0; i < node.observers.length; i += 1){
                const o = node.observers[i];
                const TransitionRunning = $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running;
                if (TransitionRunning && $44b2e6cc5a4c09f8$var$Transition.disposed.has(o)) continue;
                if (TransitionRunning ? !o.tState : !o.state) {
                    if (o.pure) $44b2e6cc5a4c09f8$var$Updates.push(o);
                    else $44b2e6cc5a4c09f8$var$Effects.push(o);
                    if (o.observers) $44b2e6cc5a4c09f8$var$markDownstream(o);
                }
                if (!TransitionRunning) o.state = $44b2e6cc5a4c09f8$var$STALE;
                else o.tState = $44b2e6cc5a4c09f8$var$STALE;
            }
            if ($44b2e6cc5a4c09f8$var$Updates.length > 10e5) {
                $44b2e6cc5a4c09f8$var$Updates = [];
                $44b2e6cc5a4c09f8$var$IS_DEV;
                throw new Error();
            }
        }, false);
    }
    return value;
}
function $44b2e6cc5a4c09f8$var$updateComputation(node) {
    if (!node.fn) return;
    $44b2e6cc5a4c09f8$var$cleanNode(node);
    const time = $44b2e6cc5a4c09f8$var$ExecCount;
    $44b2e6cc5a4c09f8$var$runComputation(node, $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running && $44b2e6cc5a4c09f8$var$Transition.sources.has(node) ? node.tValue : node.value, time);
    if ($44b2e6cc5a4c09f8$var$Transition && !$44b2e6cc5a4c09f8$var$Transition.running && $44b2e6cc5a4c09f8$var$Transition.sources.has(node)) queueMicrotask(()=>{
        $44b2e6cc5a4c09f8$var$runUpdates(()=>{
            $44b2e6cc5a4c09f8$var$Transition && ($44b2e6cc5a4c09f8$var$Transition.running = true);
            $44b2e6cc5a4c09f8$var$Listener = $44b2e6cc5a4c09f8$var$Owner = node;
            $44b2e6cc5a4c09f8$var$runComputation(node, node.tValue, time);
            $44b2e6cc5a4c09f8$var$Listener = $44b2e6cc5a4c09f8$var$Owner = null;
        }, false);
    });
}
function $44b2e6cc5a4c09f8$var$runComputation(node, value, time) {
    let nextValue;
    const owner = $44b2e6cc5a4c09f8$var$Owner, listener = $44b2e6cc5a4c09f8$var$Listener;
    $44b2e6cc5a4c09f8$var$Listener = $44b2e6cc5a4c09f8$var$Owner = node;
    try {
        nextValue = node.fn(value);
    } catch (err) {
        if (node.pure) {
            if ($44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running) {
                node.tState = $44b2e6cc5a4c09f8$var$STALE;
                node.tOwned && node.tOwned.forEach($44b2e6cc5a4c09f8$var$cleanNode);
                node.tOwned = undefined;
            } else {
                node.state = $44b2e6cc5a4c09f8$var$STALE;
                node.owned && node.owned.forEach($44b2e6cc5a4c09f8$var$cleanNode);
                node.owned = null;
            }
        }
        node.updatedAt = time + 1;
        return $44b2e6cc5a4c09f8$var$handleError(err);
    } finally{
        $44b2e6cc5a4c09f8$var$Listener = listener;
        $44b2e6cc5a4c09f8$var$Owner = owner;
    }
    if (!node.updatedAt || node.updatedAt <= time) {
        if (node.updatedAt != null && "observers" in node) $44b2e6cc5a4c09f8$var$writeSignal(node, nextValue, true);
        else if ($44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running && node.pure) {
            $44b2e6cc5a4c09f8$var$Transition.sources.add(node);
            node.tValue = nextValue;
        } else node.value = nextValue;
        node.updatedAt = time;
    }
}
function $44b2e6cc5a4c09f8$var$createComputation(fn, init, pure, state = $44b2e6cc5a4c09f8$var$STALE, options) {
    const c = {
        fn: fn,
        state: state,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: init,
        owner: $44b2e6cc5a4c09f8$var$Owner,
        context: $44b2e6cc5a4c09f8$var$Owner ? $44b2e6cc5a4c09f8$var$Owner.context : null,
        pure: pure
    };
    if ($44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running) {
        c.state = 0;
        c.tState = state;
    }
    if ($44b2e6cc5a4c09f8$var$Owner === null) ;
    else if ($44b2e6cc5a4c09f8$var$Owner !== $44b2e6cc5a4c09f8$var$UNOWNED) {
        if ($44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running && $44b2e6cc5a4c09f8$var$Owner.pure) {
            if (!$44b2e6cc5a4c09f8$var$Owner.tOwned) $44b2e6cc5a4c09f8$var$Owner.tOwned = [
                c
            ];
            else $44b2e6cc5a4c09f8$var$Owner.tOwned.push(c);
        } else if (!$44b2e6cc5a4c09f8$var$Owner.owned) $44b2e6cc5a4c09f8$var$Owner.owned = [
            c
        ];
        else $44b2e6cc5a4c09f8$var$Owner.owned.push(c);
    }
    if ($44b2e6cc5a4c09f8$var$ExternalSourceConfig && c.fn) {
        const [track, trigger] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(undefined, {
            equals: false
        });
        const ordinary = $44b2e6cc5a4c09f8$var$ExternalSourceConfig.factory(c.fn, trigger);
        $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab(()=>ordinary.dispose());
        const triggerInTransition = ()=>$44b2e6cc5a4c09f8$export$7568632d0d33d16d(trigger).then(()=>inTransition.dispose());
        const inTransition = $44b2e6cc5a4c09f8$var$ExternalSourceConfig.factory(c.fn, triggerInTransition);
        c.fn = (x)=>{
            track();
            return $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running ? inTransition.track(x) : ordinary.track(x);
        };
    }
    return c;
}
function $44b2e6cc5a4c09f8$var$runTop(node) {
    const runningTransition = $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running;
    if ((runningTransition ? node.tState : node.state) === 0) return;
    if ((runningTransition ? node.tState : node.state) === $44b2e6cc5a4c09f8$var$PENDING) return $44b2e6cc5a4c09f8$var$lookUpstream(node);
    if (node.suspense && $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(node.suspense.inFallback)) return node.suspense.effects.push(node);
    const ancestors = [
        node
    ];
    while((node = node.owner) && (!node.updatedAt || node.updatedAt < $44b2e6cc5a4c09f8$var$ExecCount)){
        if (runningTransition && $44b2e6cc5a4c09f8$var$Transition.disposed.has(node)) return;
        if (runningTransition ? node.tState : node.state) ancestors.push(node);
    }
    for(let i = ancestors.length - 1; i >= 0; i--){
        node = ancestors[i];
        if (runningTransition) {
            let top = node, prev = ancestors[i + 1];
            while((top = top.owner) && top !== prev){
                if ($44b2e6cc5a4c09f8$var$Transition.disposed.has(top)) return;
            }
        }
        if ((runningTransition ? node.tState : node.state) === $44b2e6cc5a4c09f8$var$STALE) $44b2e6cc5a4c09f8$var$updateComputation(node);
        else if ((runningTransition ? node.tState : node.state) === $44b2e6cc5a4c09f8$var$PENDING) {
            const updates = $44b2e6cc5a4c09f8$var$Updates;
            $44b2e6cc5a4c09f8$var$Updates = null;
            $44b2e6cc5a4c09f8$var$runUpdates(()=>$44b2e6cc5a4c09f8$var$lookUpstream(node, ancestors[0]), false);
            $44b2e6cc5a4c09f8$var$Updates = updates;
        }
    }
}
function $44b2e6cc5a4c09f8$var$runUpdates(fn, init) {
    if ($44b2e6cc5a4c09f8$var$Updates) return fn();
    let wait = false;
    if (!init) $44b2e6cc5a4c09f8$var$Updates = [];
    if ($44b2e6cc5a4c09f8$var$Effects) wait = true;
    else $44b2e6cc5a4c09f8$var$Effects = [];
    $44b2e6cc5a4c09f8$var$ExecCount++;
    try {
        const res = fn();
        $44b2e6cc5a4c09f8$var$completeUpdates(wait);
        return res;
    } catch (err) {
        if (!wait) $44b2e6cc5a4c09f8$var$Effects = null;
        $44b2e6cc5a4c09f8$var$Updates = null;
        $44b2e6cc5a4c09f8$var$handleError(err);
    }
}
function $44b2e6cc5a4c09f8$var$completeUpdates(wait) {
    if ($44b2e6cc5a4c09f8$var$Updates) {
        if ($44b2e6cc5a4c09f8$var$Scheduler && $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running) $44b2e6cc5a4c09f8$var$scheduleQueue($44b2e6cc5a4c09f8$var$Updates);
        else $44b2e6cc5a4c09f8$var$runQueue($44b2e6cc5a4c09f8$var$Updates);
        $44b2e6cc5a4c09f8$var$Updates = null;
    }
    if (wait) return;
    let res;
    if ($44b2e6cc5a4c09f8$var$Transition) {
        if (!$44b2e6cc5a4c09f8$var$Transition.promises.size && !$44b2e6cc5a4c09f8$var$Transition.queue.size) {
            const sources = $44b2e6cc5a4c09f8$var$Transition.sources;
            const disposed = $44b2e6cc5a4c09f8$var$Transition.disposed;
            $44b2e6cc5a4c09f8$var$Effects.push.apply($44b2e6cc5a4c09f8$var$Effects, $44b2e6cc5a4c09f8$var$Transition.effects);
            res = $44b2e6cc5a4c09f8$var$Transition.resolve;
            for (const e of $44b2e6cc5a4c09f8$var$Effects){
                "tState" in e && (e.state = e.tState);
                delete e.tState;
            }
            $44b2e6cc5a4c09f8$var$Transition = null;
            $44b2e6cc5a4c09f8$var$runUpdates(()=>{
                for (const d of disposed)$44b2e6cc5a4c09f8$var$cleanNode(d);
                for (const v of sources){
                    v.value = v.tValue;
                    if (v.owned) for(let i = 0, len = v.owned.length; i < len; i++)$44b2e6cc5a4c09f8$var$cleanNode(v.owned[i]);
                    if (v.tOwned) v.owned = v.tOwned;
                    delete v.tValue;
                    delete v.tOwned;
                    v.tState = 0;
                }
                $44b2e6cc5a4c09f8$var$setTransPending(false);
            }, false);
        } else if ($44b2e6cc5a4c09f8$var$Transition.running) {
            $44b2e6cc5a4c09f8$var$Transition.running = false;
            $44b2e6cc5a4c09f8$var$Transition.effects.push.apply($44b2e6cc5a4c09f8$var$Transition.effects, $44b2e6cc5a4c09f8$var$Effects);
            $44b2e6cc5a4c09f8$var$Effects = null;
            $44b2e6cc5a4c09f8$var$setTransPending(true);
            return;
        }
    }
    const e = $44b2e6cc5a4c09f8$var$Effects;
    $44b2e6cc5a4c09f8$var$Effects = null;
    if (e.length) $44b2e6cc5a4c09f8$var$runUpdates(()=>$44b2e6cc5a4c09f8$var$runEffects(e), false);
    if (res) res();
}
function $44b2e6cc5a4c09f8$var$runQueue(queue) {
    for(let i = 0; i < queue.length; i++)$44b2e6cc5a4c09f8$var$runTop(queue[i]);
}
function $44b2e6cc5a4c09f8$var$scheduleQueue(queue) {
    for(let i = 0; i < queue.length; i++){
        const item = queue[i];
        const tasks = $44b2e6cc5a4c09f8$var$Transition.queue;
        if (!tasks.has(item)) {
            tasks.add(item);
            $44b2e6cc5a4c09f8$var$Scheduler(()=>{
                tasks.delete(item);
                $44b2e6cc5a4c09f8$var$runUpdates(()=>{
                    $44b2e6cc5a4c09f8$var$Transition.running = true;
                    $44b2e6cc5a4c09f8$var$runTop(item);
                }, false);
                $44b2e6cc5a4c09f8$var$Transition && ($44b2e6cc5a4c09f8$var$Transition.running = false);
            });
        }
    }
}
function $44b2e6cc5a4c09f8$var$runUserEffects(queue) {
    let i, userLength = 0;
    for(i = 0; i < queue.length; i++){
        const e = queue[i];
        if (!e.user) $44b2e6cc5a4c09f8$var$runTop(e);
        else queue[userLength++] = e;
    }
    if ($44b2e6cc5a4c09f8$export$2cb4986bed338027.context) {
        if ($44b2e6cc5a4c09f8$export$2cb4986bed338027.count) {
            $44b2e6cc5a4c09f8$export$2cb4986bed338027.effects || ($44b2e6cc5a4c09f8$export$2cb4986bed338027.effects = []);
            $44b2e6cc5a4c09f8$export$2cb4986bed338027.effects.push(...queue.slice(0, userLength));
            return;
        }
        $44b2e6cc5a4c09f8$var$setHydrateContext();
    }
    if ($44b2e6cc5a4c09f8$export$2cb4986bed338027.effects && ($44b2e6cc5a4c09f8$export$2cb4986bed338027.done || !$44b2e6cc5a4c09f8$export$2cb4986bed338027.count)) {
        queue = [
            ...$44b2e6cc5a4c09f8$export$2cb4986bed338027.effects,
            ...queue
        ];
        userLength += $44b2e6cc5a4c09f8$export$2cb4986bed338027.effects.length;
        delete $44b2e6cc5a4c09f8$export$2cb4986bed338027.effects;
    }
    for(i = 0; i < userLength; i++)$44b2e6cc5a4c09f8$var$runTop(queue[i]);
}
function $44b2e6cc5a4c09f8$var$lookUpstream(node, ignore) {
    const runningTransition = $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running;
    if (runningTransition) node.tState = 0;
    else node.state = 0;
    for(let i = 0; i < node.sources.length; i += 1){
        const source = node.sources[i];
        if (source.sources) {
            const state = runningTransition ? source.tState : source.state;
            if (state === $44b2e6cc5a4c09f8$var$STALE) {
                if (source !== ignore && (!source.updatedAt || source.updatedAt < $44b2e6cc5a4c09f8$var$ExecCount)) $44b2e6cc5a4c09f8$var$runTop(source);
            } else if (state === $44b2e6cc5a4c09f8$var$PENDING) $44b2e6cc5a4c09f8$var$lookUpstream(source, ignore);
        }
    }
}
function $44b2e6cc5a4c09f8$var$markDownstream(node) {
    const runningTransition = $44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running;
    for(let i = 0; i < node.observers.length; i += 1){
        const o = node.observers[i];
        if (runningTransition ? !o.tState : !o.state) {
            if (runningTransition) o.tState = $44b2e6cc5a4c09f8$var$PENDING;
            else o.state = $44b2e6cc5a4c09f8$var$PENDING;
            if (o.pure) $44b2e6cc5a4c09f8$var$Updates.push(o);
            else $44b2e6cc5a4c09f8$var$Effects.push(o);
            o.observers && $44b2e6cc5a4c09f8$var$markDownstream(o);
        }
    }
}
function $44b2e6cc5a4c09f8$var$cleanNode(node) {
    let i;
    if (node.sources) while(node.sources.length){
        const source = node.sources.pop(), index = node.sourceSlots.pop(), obs = source.observers;
        if (obs && obs.length) {
            const n = obs.pop(), s = source.observerSlots.pop();
            if (index < obs.length) {
                n.sourceSlots[s] = index;
                obs[index] = n;
                source.observerSlots[index] = s;
            }
        }
    }
    if (node.tOwned) {
        for(i = node.tOwned.length - 1; i >= 0; i--)$44b2e6cc5a4c09f8$var$cleanNode(node.tOwned[i]);
        delete node.tOwned;
    }
    if ($44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running && node.pure) $44b2e6cc5a4c09f8$var$reset(node, true);
    else if (node.owned) {
        for(i = node.owned.length - 1; i >= 0; i--)$44b2e6cc5a4c09f8$var$cleanNode(node.owned[i]);
        node.owned = null;
    }
    if (node.cleanups) {
        for(i = node.cleanups.length - 1; i >= 0; i--)node.cleanups[i]();
        node.cleanups = null;
    }
    if ($44b2e6cc5a4c09f8$var$Transition && $44b2e6cc5a4c09f8$var$Transition.running) node.tState = 0;
    else node.state = 0;
}
function $44b2e6cc5a4c09f8$var$reset(node, top) {
    if (!top) {
        node.tState = 0;
        $44b2e6cc5a4c09f8$var$Transition.disposed.add(node);
    }
    if (node.owned) for(let i = 0; i < node.owned.length; i++)$44b2e6cc5a4c09f8$var$reset(node.owned[i]);
}
function $44b2e6cc5a4c09f8$var$castError(err) {
    if (err instanceof Error) return err;
    return new Error(typeof err === "string" ? err : "Unknown error", {
        cause: err
    });
}
function $44b2e6cc5a4c09f8$var$runErrors(err, fns, owner) {
    try {
        for (const f of fns)f(err);
    } catch (e) {
        $44b2e6cc5a4c09f8$var$handleError(e, owner && owner.owner || null);
    }
}
function $44b2e6cc5a4c09f8$var$handleError(err, owner = $44b2e6cc5a4c09f8$var$Owner) {
    const fns = $44b2e6cc5a4c09f8$var$ERROR && owner && owner.context && owner.context[$44b2e6cc5a4c09f8$var$ERROR];
    const error = $44b2e6cc5a4c09f8$var$castError(err);
    if (!fns) throw error;
    if ($44b2e6cc5a4c09f8$var$Effects) $44b2e6cc5a4c09f8$var$Effects.push({
        fn () {
            $44b2e6cc5a4c09f8$var$runErrors(error, fns, owner);
        },
        state: $44b2e6cc5a4c09f8$var$STALE
    });
    else $44b2e6cc5a4c09f8$var$runErrors(error, fns, owner);
}
function $44b2e6cc5a4c09f8$var$resolveChildren(children) {
    if (typeof children === "function" && !children.length) return $44b2e6cc5a4c09f8$var$resolveChildren(children());
    if (Array.isArray(children)) {
        const results = [];
        for(let i = 0; i < children.length; i++){
            const result = $44b2e6cc5a4c09f8$var$resolveChildren(children[i]);
            Array.isArray(result) ? results.push.apply(results, result) : results.push(result);
        }
        return results;
    }
    return children;
}
function $44b2e6cc5a4c09f8$var$createProvider(id, options) {
    return function provider(props) {
        let res;
        $44b2e6cc5a4c09f8$export$314dade334ae905d(()=>res = $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>{
                $44b2e6cc5a4c09f8$var$Owner.context = {
                    ...$44b2e6cc5a4c09f8$var$Owner.context,
                    [id]: props.value
                };
                return $44b2e6cc5a4c09f8$export$bacb5cc5a11aef16(()=>props.children);
            }), undefined);
        return res;
    };
}
function $44b2e6cc5a4c09f8$export$2288787135a8f66e(fn) {
    $44b2e6cc5a4c09f8$var$ERROR || ($44b2e6cc5a4c09f8$var$ERROR = Symbol("error"));
    if ($44b2e6cc5a4c09f8$var$Owner === null) ;
    else if ($44b2e6cc5a4c09f8$var$Owner.context === null || !$44b2e6cc5a4c09f8$var$Owner.context[$44b2e6cc5a4c09f8$var$ERROR]) {
        $44b2e6cc5a4c09f8$var$Owner.context = {
            ...$44b2e6cc5a4c09f8$var$Owner.context,
            [$44b2e6cc5a4c09f8$var$ERROR]: [
                fn
            ]
        };
        $44b2e6cc5a4c09f8$var$mutateContext($44b2e6cc5a4c09f8$var$Owner, $44b2e6cc5a4c09f8$var$ERROR, [
            fn
        ]);
    } else $44b2e6cc5a4c09f8$var$Owner.context[$44b2e6cc5a4c09f8$var$ERROR].push(fn);
}
function $44b2e6cc5a4c09f8$var$mutateContext(o, key, value) {
    if (o.owned) for(let i = 0; i < o.owned.length; i++){
        if (o.owned[i].context === o.context) $44b2e6cc5a4c09f8$var$mutateContext(o.owned[i], key, value);
        if (!o.owned[i].context) {
            o.owned[i].context = o.context;
            $44b2e6cc5a4c09f8$var$mutateContext(o.owned[i], key, value);
        } else if (!o.owned[i].context[key]) {
            o.owned[i].context[key] = value;
            $44b2e6cc5a4c09f8$var$mutateContext(o.owned[i], key, value);
        }
    }
}
function $44b2e6cc5a4c09f8$export$5ab46cbf6120b33a(input) {
    return {
        subscribe (observer) {
            if (!(observer instanceof Object) || observer == null) throw new TypeError("Expected the observer to be an object.");
            const handler = typeof observer === "function" ? observer : observer.next && observer.next.bind(observer);
            if (!handler) return {
                unsubscribe () {}
            };
            const dispose = $44b2e6cc5a4c09f8$export$882461b6382ed46c((disposer)=>{
                $44b2e6cc5a4c09f8$export$7ea7134f704deda4(()=>{
                    const v = input();
                    $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>handler(v));
                });
                return disposer;
            });
            if ($44b2e6cc5a4c09f8$export$5f4ed0d56c2c0edf()) $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab(dispose);
            return {
                unsubscribe () {
                    dispose();
                }
            };
        },
        [Symbol.observable || "@@observable"] () {
            return this;
        }
    };
}
function $44b2e6cc5a4c09f8$export$6788812c4e6611e6(producer, initalValue) {
    const [s, set] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(initalValue, {
        equals: false
    });
    if ("subscribe" in producer) {
        const unsub = producer.subscribe((v)=>set(()=>v));
        $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab(()=>"unsubscribe" in unsub ? unsub.unsubscribe() : unsub());
    } else {
        const clean = producer(set);
        $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab(clean);
    }
    return s;
}
const $44b2e6cc5a4c09f8$var$FALLBACK = Symbol("fallback");
function $44b2e6cc5a4c09f8$var$dispose(d) {
    for(let i = 0; i < d.length; i++)d[i]();
}
function $44b2e6cc5a4c09f8$export$4c9116dcf1374231(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], len = 0, indexes = mapFn.length > 1 ? [] : null;
    $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab(()=>$44b2e6cc5a4c09f8$var$dispose(disposers));
    return ()=>{
        let newItems = list() || [], newLen = newItems.length, i, j;
        newItems[$44b2e6cc5a4c09f8$export$17a675b7c02a7b1d];
        return $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>{
            let newIndices, newIndicesNext, temp, tempdisposers, tempIndexes, start, end, newEnd, item;
            if (newLen === 0) {
                if (len !== 0) {
                    $44b2e6cc5a4c09f8$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    indexes && (indexes = []);
                }
                if (options.fallback) {
                    items = [
                        $44b2e6cc5a4c09f8$var$FALLBACK
                    ];
                    mapped[0] = $44b2e6cc5a4c09f8$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
            } else if (len === 0) {
                mapped = new Array(newLen);
                for(j = 0; j < newLen; j++){
                    items[j] = newItems[j];
                    mapped[j] = $44b2e6cc5a4c09f8$export$882461b6382ed46c(mapper);
                }
                len = newLen;
            } else {
                temp = new Array(newLen);
                tempdisposers = new Array(newLen);
                indexes && (tempIndexes = new Array(newLen));
                for(start = 0, end = Math.min(len, newLen); start < end && items[start] === newItems[start]; start++);
                for(end = len - 1, newEnd = newLen - 1; end >= start && newEnd >= start && items[end] === newItems[newEnd]; end--, newEnd--){
                    temp[newEnd] = mapped[end];
                    tempdisposers[newEnd] = disposers[end];
                    indexes && (tempIndexes[newEnd] = indexes[end]);
                }
                newIndices = new Map();
                newIndicesNext = new Array(newEnd + 1);
                for(j = newEnd; j >= start; j--){
                    item = newItems[j];
                    i = newIndices.get(item);
                    newIndicesNext[j] = i === undefined ? -1 : i;
                    newIndices.set(item, j);
                }
                for(i = start; i <= end; i++){
                    item = items[i];
                    j = newIndices.get(item);
                    if (j !== undefined && j !== -1) {
                        temp[j] = mapped[i];
                        tempdisposers[j] = disposers[i];
                        indexes && (tempIndexes[j] = indexes[i]);
                        j = newIndicesNext[j];
                        newIndices.set(item, j);
                    } else disposers[i]();
                }
                for(j = start; j < newLen; j++)if (j in temp) {
                    mapped[j] = temp[j];
                    disposers[j] = tempdisposers[j];
                    if (indexes) {
                        indexes[j] = tempIndexes[j];
                        indexes[j](j);
                    }
                } else mapped[j] = $44b2e6cc5a4c09f8$export$882461b6382ed46c(mapper);
                mapped = mapped.slice(0, len = newLen);
                items = newItems.slice(0);
            }
            return mapped;
        });
        function mapper(disposer) {
            disposers[j] = disposer;
            if (indexes) {
                const [s, set] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(j);
                indexes[j] = set;
                return mapFn(newItems[j], s);
            }
            return mapFn(newItems[j]);
        }
    };
}
function $44b2e6cc5a4c09f8$export$2cd1c249765cd0a4(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], signals = [], len = 0, i;
    $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab(()=>$44b2e6cc5a4c09f8$var$dispose(disposers));
    return ()=>{
        const newItems = list() || [], newLen = newItems.length;
        newItems[$44b2e6cc5a4c09f8$export$17a675b7c02a7b1d];
        return $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>{
            if (newLen === 0) {
                if (len !== 0) {
                    $44b2e6cc5a4c09f8$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    signals = [];
                }
                if (options.fallback) {
                    items = [
                        $44b2e6cc5a4c09f8$var$FALLBACK
                    ];
                    mapped[0] = $44b2e6cc5a4c09f8$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
                return mapped;
            }
            if (items[0] === $44b2e6cc5a4c09f8$var$FALLBACK) {
                disposers[0]();
                disposers = [];
                items = [];
                mapped = [];
                len = 0;
            }
            for(i = 0; i < newLen; i++){
                if (i < items.length && items[i] !== newItems[i]) signals[i](()=>newItems[i]);
                else if (i >= items.length) mapped[i] = $44b2e6cc5a4c09f8$export$882461b6382ed46c(mapper);
            }
            for(; i < items.length; i++)disposers[i]();
            len = signals.length = disposers.length = newLen;
            items = newItems.slice(0);
            return mapped = mapped.slice(0, len);
        });
        function mapper(disposer) {
            disposers[i] = disposer;
            const [s, set] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(newItems[i]);
            signals[i] = set;
            return mapFn(s, i);
        }
    };
}
let $44b2e6cc5a4c09f8$var$hydrationEnabled = false;
function $44b2e6cc5a4c09f8$export$849801d35d2160c9() {
    $44b2e6cc5a4c09f8$var$hydrationEnabled = true;
}
function $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38(Comp, props) {
    if ($44b2e6cc5a4c09f8$var$hydrationEnabled) {
        if ($44b2e6cc5a4c09f8$export$2cb4986bed338027.context) {
            const c = $44b2e6cc5a4c09f8$export$2cb4986bed338027.context;
            $44b2e6cc5a4c09f8$var$setHydrateContext($44b2e6cc5a4c09f8$var$nextHydrateContext());
            const r = $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>Comp(props || {}));
            $44b2e6cc5a4c09f8$var$setHydrateContext(c);
            return r;
        }
    }
    return $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>Comp(props || {}));
}
function $44b2e6cc5a4c09f8$var$trueFn() {
    return true;
}
const $44b2e6cc5a4c09f8$var$propTraps = {
    get (_, property, receiver) {
        if (property === $44b2e6cc5a4c09f8$export$5cd89106e2f6c2c5) return receiver;
        return _.get(property);
    },
    has (_, property) {
        if (property === $44b2e6cc5a4c09f8$export$5cd89106e2f6c2c5) return true;
        return _.has(property);
    },
    set: $44b2e6cc5a4c09f8$var$trueFn,
    deleteProperty: $44b2e6cc5a4c09f8$var$trueFn,
    getOwnPropertyDescriptor (_, property) {
        return {
            configurable: true,
            enumerable: true,
            get () {
                return _.get(property);
            },
            set: $44b2e6cc5a4c09f8$var$trueFn,
            deleteProperty: $44b2e6cc5a4c09f8$var$trueFn
        };
    },
    ownKeys (_) {
        return _.keys();
    }
};
function $44b2e6cc5a4c09f8$var$resolveSource(s) {
    return !(s = typeof s === "function" ? s() : s) ? {} : s;
}
function $44b2e6cc5a4c09f8$var$resolveSources() {
    for(let i = 0, length = this.length; i < length; ++i){
        const v = this[i]();
        if (v !== undefined) return v;
    }
}
function $44b2e6cc5a4c09f8$export$9d1611c77c2fe928(...sources) {
    let proxy = false;
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        proxy = proxy || !!s && $44b2e6cc5a4c09f8$export$5cd89106e2f6c2c5 in s;
        sources[i] = typeof s === "function" ? (proxy = true, $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(s)) : s;
    }
    if ($44b2e6cc5a4c09f8$var$SUPPORTS_PROXY && proxy) return new Proxy({
        get (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                const v = $44b2e6cc5a4c09f8$var$resolveSource(sources[i])[property];
                if (v !== undefined) return v;
            }
        },
        has (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                if (property in $44b2e6cc5a4c09f8$var$resolveSource(sources[i])) return true;
            }
            return false;
        },
        keys () {
            const keys = [];
            for(let i = 0; i < sources.length; i++)keys.push(...Object.keys($44b2e6cc5a4c09f8$var$resolveSource(sources[i])));
            return [
                ...new Set(keys)
            ];
        }
    }, $44b2e6cc5a4c09f8$var$propTraps);
    const sourcesMap = {};
    const defined = Object.create(null);
    for(let i = sources.length - 1; i >= 0; i--){
        const source = sources[i];
        if (!source) continue;
        const sourceKeys = Object.getOwnPropertyNames(source);
        for(let i = sourceKeys.length - 1; i >= 0; i--){
            const key = sourceKeys[i];
            if (key === "__proto__" || key === "constructor") continue;
            const desc = Object.getOwnPropertyDescriptor(source, key);
            if (!defined[key]) defined[key] = desc.get ? {
                enumerable: true,
                configurable: true,
                get: $44b2e6cc5a4c09f8$var$resolveSources.bind(sourcesMap[key] = [
                    desc.get.bind(source)
                ])
            } : desc.value !== undefined ? desc : undefined;
            else {
                const sources = sourcesMap[key];
                if (sources) {
                    if (desc.get) sources.push(desc.get.bind(source));
                    else if (desc.value !== undefined) sources.push(()=>desc.value);
                }
            }
        }
    }
    const target = {};
    const definedKeys = Object.keys(defined);
    for(let i = definedKeys.length - 1; i >= 0; i--){
        const key = definedKeys[i], desc = defined[key];
        if (desc && desc.get) Object.defineProperty(target, key, desc);
        else target[key] = desc ? desc.value : undefined;
    }
    return target;
}
function $44b2e6cc5a4c09f8$export$45029c61b0073d87(props, ...keys) {
    if ($44b2e6cc5a4c09f8$var$SUPPORTS_PROXY && $44b2e6cc5a4c09f8$export$5cd89106e2f6c2c5 in props) {
        const blocked = new Set(keys.length > 1 ? keys.flat() : keys[0]);
        const res = keys.map((k)=>{
            return new Proxy({
                get (property) {
                    return k.includes(property) ? props[property] : undefined;
                },
                has (property) {
                    return k.includes(property) && property in props;
                },
                keys () {
                    return k.filter((property)=>property in props);
                }
            }, $44b2e6cc5a4c09f8$var$propTraps);
        });
        res.push(new Proxy({
            get (property) {
                return blocked.has(property) ? undefined : props[property];
            },
            has (property) {
                return blocked.has(property) ? false : property in props;
            },
            keys () {
                return Object.keys(props).filter((k)=>!blocked.has(k));
            }
        }, $44b2e6cc5a4c09f8$var$propTraps));
        return res;
    }
    const otherObject = {};
    const objects = keys.map(()=>({}));
    for (const propName of Object.getOwnPropertyNames(props)){
        const desc = Object.getOwnPropertyDescriptor(props, propName);
        const isDefaultDesc = !desc.get && !desc.set && desc.enumerable && desc.writable && desc.configurable;
        let blocked = false;
        let objectIndex = 0;
        for (const k of keys){
            if (k.includes(propName)) {
                blocked = true;
                isDefaultDesc ? objects[objectIndex][propName] = desc.value : Object.defineProperty(objects[objectIndex], propName, desc);
            }
            ++objectIndex;
        }
        if (!blocked) isDefaultDesc ? otherObject[propName] = desc.value : Object.defineProperty(otherObject, propName, desc);
    }
    return [
        ...objects,
        otherObject
    ];
}
function $44b2e6cc5a4c09f8$export$488013bae63b21da(fn) {
    let comp;
    let p;
    const wrap = (props)=>{
        const ctx = $44b2e6cc5a4c09f8$export$2cb4986bed338027.context;
        if (ctx) {
            const [s, set] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5();
            $44b2e6cc5a4c09f8$export$2cb4986bed338027.count || ($44b2e6cc5a4c09f8$export$2cb4986bed338027.count = 0);
            $44b2e6cc5a4c09f8$export$2cb4986bed338027.count++;
            (p || (p = fn())).then((mod)=>{
                !$44b2e6cc5a4c09f8$export$2cb4986bed338027.done && $44b2e6cc5a4c09f8$var$setHydrateContext(ctx);
                $44b2e6cc5a4c09f8$export$2cb4986bed338027.count--;
                set(()=>mod.default);
                $44b2e6cc5a4c09f8$var$setHydrateContext();
            });
            comp = s;
        } else if (!comp) {
            const [s] = $44b2e6cc5a4c09f8$export$edd172c6c83c39cc(()=>(p || (p = fn())).then((mod)=>mod.default));
            comp = s;
        }
        let Comp;
        return $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>(Comp = comp()) ? $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>{
                $44b2e6cc5a4c09f8$var$IS_DEV;
                if (!ctx || $44b2e6cc5a4c09f8$export$2cb4986bed338027.done) return Comp(props);
                const c = $44b2e6cc5a4c09f8$export$2cb4986bed338027.context;
                $44b2e6cc5a4c09f8$var$setHydrateContext(ctx);
                const r = Comp(props);
                $44b2e6cc5a4c09f8$var$setHydrateContext(c);
                return r;
            }) : "");
    };
    wrap.preload = ()=>p || ((p = fn()).then((mod)=>comp = ()=>mod.default), p);
    return wrap;
}
let $44b2e6cc5a4c09f8$var$counter = 0;
function $44b2e6cc5a4c09f8$export$33208d63bc845a83() {
    const ctx = $44b2e6cc5a4c09f8$export$2cb4986bed338027.context;
    return ctx ? $44b2e6cc5a4c09f8$export$2cb4986bed338027.getNextContextId() : `cl-${$44b2e6cc5a4c09f8$var$counter++}`;
}
const $44b2e6cc5a4c09f8$var$narrowedError = (name)=>`Stale read from <${name}>.`;
function $44b2e6cc5a4c09f8$export$bdf530073099ce9f(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa($44b2e6cc5a4c09f8$export$4c9116dcf1374231(()=>props.each, props.children, fallback || undefined));
}
function $44b2e6cc5a4c09f8$export$cf17b003b6192af3(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa($44b2e6cc5a4c09f8$export$2cd1c249765cd0a4(()=>props.each, props.children, fallback || undefined));
}
function $44b2e6cc5a4c09f8$export$f6a3d19be20f5819(props) {
    const keyed = props.keyed;
    const conditionValue = $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>props.when, undefined, undefined);
    const condition = keyed ? conditionValue : $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
        equals: (a, b)=>!a === !b
    });
    return $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>{
        const c = condition();
        if (c) {
            const child = props.children;
            const fn = typeof child === "function" && child.length > 0;
            return fn ? $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>child(keyed ? c : ()=>{
                    if (!$44b2e6cc5a4c09f8$export$363ebc4b78b8f807(condition)) throw $44b2e6cc5a4c09f8$var$narrowedError("Show");
                    return conditionValue();
                })) : child;
        }
        return props.fallback;
    }, undefined, undefined);
}
function $44b2e6cc5a4c09f8$export$b5d5cf8927ab7262(props) {
    const chs = $44b2e6cc5a4c09f8$export$bacb5cc5a11aef16(()=>props.children);
    const switchFunc = $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>{
        const ch = chs();
        const mps = Array.isArray(ch) ? ch : [
            ch
        ];
        let func = ()=>undefined;
        for(let i = 0; i < mps.length; i++){
            const index = i;
            const mp = mps[i];
            const prevFunc = func;
            const conditionValue = $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>prevFunc() ? undefined : mp.when, undefined, undefined);
            const condition = mp.keyed ? conditionValue : $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
                equals: (a, b)=>!a === !b
            });
            func = ()=>prevFunc() || (condition() ? [
                    index,
                    conditionValue,
                    mp
                ] : undefined);
        }
        return func;
    });
    return $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>{
        const sel = switchFunc()();
        if (!sel) return props.fallback;
        const [index, conditionValue, mp] = sel;
        const child = mp.children;
        const fn = typeof child === "function" && child.length > 0;
        return fn ? $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>child(mp.keyed ? conditionValue() : ()=>{
                if ($44b2e6cc5a4c09f8$export$363ebc4b78b8f807(switchFunc)()?.[0] !== index) throw $44b2e6cc5a4c09f8$var$narrowedError("Match");
                return conditionValue();
            })) : child;
    }, undefined, undefined);
}
function $44b2e6cc5a4c09f8$export$f421feb8fad20413(props) {
    return props;
}
let $44b2e6cc5a4c09f8$var$Errors;
function $44b2e6cc5a4c09f8$export$4eaee74ee7a14dca() {
    $44b2e6cc5a4c09f8$var$Errors && [
        ...$44b2e6cc5a4c09f8$var$Errors
    ].forEach((fn)=>fn());
}
function $44b2e6cc5a4c09f8$export$e926676385687eaf(props) {
    let err;
    if ($44b2e6cc5a4c09f8$export$2cb4986bed338027.context && $44b2e6cc5a4c09f8$export$2cb4986bed338027.load) err = $44b2e6cc5a4c09f8$export$2cb4986bed338027.load($44b2e6cc5a4c09f8$export$2cb4986bed338027.getContextId());
    const [errored, setErrored] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(err, undefined);
    $44b2e6cc5a4c09f8$var$Errors || ($44b2e6cc5a4c09f8$var$Errors = new Set());
    $44b2e6cc5a4c09f8$var$Errors.add(setErrored);
    $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab(()=>$44b2e6cc5a4c09f8$var$Errors.delete(setErrored));
    return $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>{
        let e;
        if (e = errored()) {
            const f = props.fallback;
            return typeof f === "function" && f.length ? $44b2e6cc5a4c09f8$export$363ebc4b78b8f807(()=>f(e, ()=>setErrored())) : f;
        }
        return $44b2e6cc5a4c09f8$export$3dede90624df3ba9(()=>props.children, setErrored);
    }, undefined, undefined);
}
const $44b2e6cc5a4c09f8$var$suspenseListEquals = (a, b)=>a.showContent === b.showContent && a.showFallback === b.showFallback;
const $44b2e6cc5a4c09f8$var$SuspenseListContext = /* #__PURE__ */ $44b2e6cc5a4c09f8$export$fd42f52fd3ae1109();
function $44b2e6cc5a4c09f8$export$998bcd577473dd93(props) {
    let [wrapper, setWrapper] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(()=>({
            inFallback: false
        })), show;
    const listContext = $44b2e6cc5a4c09f8$export$fae74005e78b1a27($44b2e6cc5a4c09f8$var$SuspenseListContext);
    const [registry, setRegistry] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5([]);
    if (listContext) show = listContext.register($44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>wrapper()().inFallback));
    const resolved = $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa((prev)=>{
        const reveal = props.revealOrder, tail = props.tail, { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {}, reg = registry(), reverse = reveal === "backwards";
        if (reveal === "together") {
            const all = reg.every((inFallback)=>!inFallback());
            const res = reg.map(()=>({
                    showContent: all && showContent,
                    showFallback: showFallback
                }));
            res.inFallback = !all;
            return res;
        }
        let stop = false;
        let inFallback = prev.inFallback;
        const res = [];
        for(let i = 0, len = reg.length; i < len; i++){
            const n = reverse ? len - i - 1 : i, s = reg[n]();
            if (!stop && !s) res[n] = {
                showContent: showContent,
                showFallback: showFallback
            };
            else {
                const next = !stop;
                if (next) inFallback = true;
                res[n] = {
                    showContent: next,
                    showFallback: !tail || next && tail === "collapsed" ? showFallback : false
                };
                stop = true;
            }
        }
        if (!stop) inFallback = false;
        res.inFallback = inFallback;
        return res;
    }, {
        inFallback: false
    });
    setWrapper(()=>resolved);
    return $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38($44b2e6cc5a4c09f8$var$SuspenseListContext.Provider, {
        value: {
            register: (inFallback)=>{
                let index;
                setRegistry((registry)=>{
                    index = registry.length;
                    return [
                        ...registry,
                        inFallback
                    ];
                });
                return $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>resolved()[index], undefined, {
                    equals: $44b2e6cc5a4c09f8$var$suspenseListEquals
                });
            }
        },
        get children () {
            return props.children;
        }
    });
}
function $44b2e6cc5a4c09f8$export$74bf444e3cd11ea5(props) {
    let counter = 0, show, ctx, p, flicker, error;
    const [inFallback, setFallback] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(false), SuspenseContext = $44b2e6cc5a4c09f8$var$getSuspenseContext(), store = {
        increment: ()=>{
            if (++counter === 1) setFallback(true);
        },
        decrement: ()=>{
            if (--counter === 0) setFallback(false);
        },
        inFallback: inFallback,
        effects: [],
        resolved: false
    }, owner = $44b2e6cc5a4c09f8$export$5f4ed0d56c2c0edf();
    if ($44b2e6cc5a4c09f8$export$2cb4986bed338027.context && $44b2e6cc5a4c09f8$export$2cb4986bed338027.load) {
        const key = $44b2e6cc5a4c09f8$export$2cb4986bed338027.getContextId();
        let ref = $44b2e6cc5a4c09f8$export$2cb4986bed338027.load(key);
        if (ref) {
            if (typeof ref !== "object" || ref.s !== 1) p = ref;
            else $44b2e6cc5a4c09f8$export$2cb4986bed338027.gather(key);
        }
        if (p && p !== "$$f") {
            const [s, set] = $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5(undefined, {
                equals: false
            });
            flicker = s;
            p.then(()=>{
                if ($44b2e6cc5a4c09f8$export$2cb4986bed338027.done) return set();
                $44b2e6cc5a4c09f8$export$2cb4986bed338027.gather(key);
                $44b2e6cc5a4c09f8$var$setHydrateContext(ctx);
                set();
                $44b2e6cc5a4c09f8$var$setHydrateContext();
            }, (err)=>{
                error = err;
                set();
            });
        }
    }
    const listContext = $44b2e6cc5a4c09f8$export$fae74005e78b1a27($44b2e6cc5a4c09f8$var$SuspenseListContext);
    if (listContext) show = listContext.register(store.inFallback);
    let dispose;
    $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab(()=>dispose && dispose());
    return $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38(SuspenseContext.Provider, {
        value: store,
        get children () {
            return $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>{
                if (error) throw error;
                ctx = $44b2e6cc5a4c09f8$export$2cb4986bed338027.context;
                if (flicker) {
                    flicker();
                    return flicker = undefined;
                }
                if (ctx && p === "$$f") $44b2e6cc5a4c09f8$var$setHydrateContext();
                const rendered = $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa(()=>props.children);
                return $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa((prev)=>{
                    const inFallback = store.inFallback(), { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {};
                    if ((!inFallback || p && p !== "$$f") && showContent) {
                        store.resolved = true;
                        dispose && dispose();
                        dispose = ctx = p = undefined;
                        $44b2e6cc5a4c09f8$var$resumeEffects(store.effects);
                        return rendered();
                    }
                    if (!showFallback) return;
                    if (dispose) return prev;
                    return $44b2e6cc5a4c09f8$export$882461b6382ed46c((disposer)=>{
                        dispose = disposer;
                        if (ctx) {
                            $44b2e6cc5a4c09f8$var$setHydrateContext({
                                id: ctx.id + "F",
                                count: 0
                            });
                            ctx = undefined;
                        }
                        return props.fallback;
                    }, owner);
                });
            });
        }
    });
}
const $44b2e6cc5a4c09f8$export$404582bc18fe4d9e = undefined;


const $5ad41d0ab9107ecf$var$booleans = [
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected"
];
const $5ad41d0ab9107ecf$export$8714badcfa4caafb = /*#__PURE__*/ new Set([
    "className",
    "value",
    "readOnly",
    "noValidate",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    ...$5ad41d0ab9107ecf$var$booleans
]);
const $5ad41d0ab9107ecf$export$2c72a9edec54d5d9 = /*#__PURE__*/ new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]);
const $5ad41d0ab9107ecf$export$8915b7db7f70cfed = /*#__PURE__*/ Object.assign(Object.create(null), {
    className: "class",
    htmlFor: "for"
});
const $5ad41d0ab9107ecf$var$PropAliases = /*#__PURE__*/ Object.assign(Object.create(null), {
    class: "className",
    novalidate: {
        $: "noValidate",
        FORM: 1
    },
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    }
});
function $5ad41d0ab9107ecf$export$72dcdd3761a309a9(prop, tagName) {
    const a = $5ad41d0ab9107ecf$var$PropAliases[prop];
    return typeof a === "object" ? a[tagName] ? a["$"] : undefined : a;
}
const $5ad41d0ab9107ecf$export$389d7c657d123a81 = /*#__PURE__*/ new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]);
const $5ad41d0ab9107ecf$export$ccaf9b9a82de4b98 = /*#__PURE__*/ new Set([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "set",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
]);
const $5ad41d0ab9107ecf$export$fa927d1d0495a67d = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
const $5ad41d0ab9107ecf$export$87d0e790667228e9 = /*#__PURE__*/ new Set([
    "html",
    "base",
    "head",
    "link",
    "meta",
    "style",
    "title",
    "body",
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "main",
    "nav",
    "section",
    "body",
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "ol",
    "p",
    "pre",
    "ul",
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    "area",
    "audio",
    "img",
    "map",
    "track",
    "video",
    "embed",
    "iframe",
    "object",
    "param",
    "picture",
    "portal",
    "source",
    "svg",
    "math",
    "canvas",
    "noscript",
    "script",
    "del",
    "ins",
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "button",
    "datalist",
    "fieldset",
    "form",
    "input",
    "label",
    "legend",
    "meter",
    "optgroup",
    "option",
    "output",
    "progress",
    "select",
    "textarea",
    "details",
    "dialog",
    "menu",
    "summary",
    "details",
    "slot",
    "template",
    "acronym",
    "applet",
    "basefont",
    "bgsound",
    "big",
    "blink",
    "center",
    "content",
    "dir",
    "font",
    "frame",
    "frameset",
    "hgroup",
    "image",
    "keygen",
    "marquee",
    "menuitem",
    "nobr",
    "noembed",
    "noframes",
    "plaintext",
    "rb",
    "rtc",
    "shadow",
    "spacer",
    "strike",
    "tt",
    "xmp",
    "a",
    "abbr",
    "acronym",
    "address",
    "applet",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "basefont",
    "bdi",
    "bdo",
    "bgsound",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "frame",
    "frameset",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "image",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "nobr",
    "noembed",
    "noframes",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "plaintext",
    "portal",
    "pre",
    "progress",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "shadow",
    "slot",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "xmp",
    "input",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
]);
const $5ad41d0ab9107ecf$export$7c73462e0d25e514 = (fn)=>(0, $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa)(()=>fn());
function $5ad41d0ab9107ecf$var$reconcileArrays(parentNode, a, b) {
    let bLength = b.length, aEnd = a.length, bEnd = bLength, aStart = 0, bStart = 0, after = a[aEnd - 1].nextSibling, map = null;
    while(aStart < aEnd || bStart < bEnd){
        if (a[aStart] === b[bStart]) {
            aStart++;
            bStart++;
            continue;
        }
        while(a[aEnd - 1] === b[bEnd - 1]){
            aEnd--;
            bEnd--;
        }
        if (aEnd === aStart) {
            const node = bEnd < bLength ? bStart ? b[bStart - 1].nextSibling : b[bEnd - bStart] : after;
            while(bStart < bEnd)parentNode.insertBefore(b[bStart++], node);
        } else if (bEnd === bStart) while(aStart < aEnd){
            if (!map || !map.has(a[aStart])) a[aStart].remove();
            aStart++;
        }
        else if (a[aStart] === b[bEnd - 1] && b[bStart] === a[aEnd - 1]) {
            const node = a[--aEnd].nextSibling;
            parentNode.insertBefore(b[bStart++], a[aStart++].nextSibling);
            parentNode.insertBefore(b[--bEnd], node);
            a[aEnd] = b[bEnd];
        } else {
            if (!map) {
                map = new Map();
                let i = bStart;
                while(i < bEnd)map.set(b[i], i++);
            }
            const index = map.get(a[aStart]);
            if (index != null) {
                if (bStart < index && index < bEnd) {
                    let i = aStart, sequence = 1, t;
                    while(++i < aEnd && i < bEnd){
                        if ((t = map.get(a[i])) == null || t !== index + sequence) break;
                        sequence++;
                    }
                    if (sequence > index - bStart) {
                        const node = a[aStart];
                        while(bStart < index)parentNode.insertBefore(b[bStart++], node);
                    } else parentNode.replaceChild(b[bStart++], a[aStart++]);
                } else aStart++;
            } else a[aStart++].remove();
        }
    }
}
const $5ad41d0ab9107ecf$var$$$EVENTS = "_$DX_DELEGATE";
function $5ad41d0ab9107ecf$export$b3890eb0ae9dca99(code, element, init, options = {}) {
    let disposer;
    (0, $44b2e6cc5a4c09f8$export$882461b6382ed46c)((dispose)=>{
        disposer = dispose;
        element === document ? code() : $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff(element, code(), element.firstChild ? null : undefined, init);
    }, options.owner);
    return ()=>{
        disposer();
        element.textContent = "";
    };
}
function $5ad41d0ab9107ecf$export$ce69bd05624d0c48(html, isImportNode, isSVG, isMathML) {
    let node;
    const create = ()=>{
        const t = isMathML ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
        t.innerHTML = html;
        return isSVG ? t.content.firstChild.firstChild : isMathML ? t.firstChild : t.content.firstChild;
    };
    const fn = isImportNode ? ()=>(0, $44b2e6cc5a4c09f8$export$363ebc4b78b8f807)(()=>document.importNode(node || (node = create()), true)) : ()=>(node || (node = create())).cloneNode(true);
    fn.cloneNode = fn;
    return fn;
}
function $5ad41d0ab9107ecf$export$ad0f7f87f67e17d6(eventNames, document1 = window.document) {
    const e = document1[$5ad41d0ab9107ecf$var$$$EVENTS] || (document1[$5ad41d0ab9107ecf$var$$$EVENTS] = new Set());
    for(let i = 0, l = eventNames.length; i < l; i++){
        const name = eventNames[i];
        if (!e.has(name)) {
            e.add(name);
            document1.addEventListener(name, $5ad41d0ab9107ecf$var$eventHandler);
        }
    }
}
function $5ad41d0ab9107ecf$export$aedd29ca2033b694(document1 = window.document) {
    if (document1[$5ad41d0ab9107ecf$var$$$EVENTS]) {
        for (let name of document1[$5ad41d0ab9107ecf$var$$$EVENTS].keys())document1.removeEventListener(name, $5ad41d0ab9107ecf$var$eventHandler);
        delete document1[$5ad41d0ab9107ecf$var$$$EVENTS];
    }
}
function $5ad41d0ab9107ecf$export$a41c68a4eb5ff164(node, name, value) {
    if ($5ad41d0ab9107ecf$var$isHydrating(node)) return;
    node[name] = value;
}
function $5ad41d0ab9107ecf$export$9fec4d97f1922e0b(node, name, value) {
    if ($5ad41d0ab9107ecf$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute(name);
    else node.setAttribute(name, value);
}
function $5ad41d0ab9107ecf$export$75900142c9e21800(node, namespace, name, value) {
    if ($5ad41d0ab9107ecf$var$isHydrating(node)) return;
    if (value == null) node.removeAttributeNS(namespace, name);
    else node.setAttributeNS(namespace, name, value);
}
function $5ad41d0ab9107ecf$export$248913d9a30bef7a(node, name, value) {
    if ($5ad41d0ab9107ecf$var$isHydrating(node)) return;
    value ? node.setAttribute(name, "") : node.removeAttribute(name);
}
function $5ad41d0ab9107ecf$export$2913c0c0b5623090(node, value) {
    if ($5ad41d0ab9107ecf$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute("class");
    else node.className = value;
}
function $5ad41d0ab9107ecf$export$3f65cefe8380dbea(node, name, handler, delegate) {
    if (delegate) {
        if (Array.isArray(handler)) {
            node[`$$${name}`] = handler[0];
            node[`$$${name}Data`] = handler[1];
        } else node[`$$${name}`] = handler;
    } else if (Array.isArray(handler)) {
        const handlerFn = handler[0];
        node.addEventListener(name, handler[0] = (e)=>handlerFn.call(node, handler[1], e));
    } else node.addEventListener(name, handler, typeof handler !== "function" && handler);
}
function $5ad41d0ab9107ecf$export$11c615ce16f87241(node, value, prev = {}) {
    const classKeys = Object.keys(value || {}), prevKeys = Object.keys(prev);
    let i, len;
    for(i = 0, len = prevKeys.length; i < len; i++){
        const key = prevKeys[i];
        if (!key || key === "undefined" || value[key]) continue;
        $5ad41d0ab9107ecf$var$toggleClassKey(node, key, false);
        delete prev[key];
    }
    for(i = 0, len = classKeys.length; i < len; i++){
        const key = classKeys[i], classValue = !!value[key];
        if (!key || key === "undefined" || prev[key] === classValue || !classValue) continue;
        $5ad41d0ab9107ecf$var$toggleClassKey(node, key, true);
        prev[key] = classValue;
    }
    return prev;
}
function $5ad41d0ab9107ecf$export$1d567c320f4763bc(node, value, prev) {
    if (!value) return prev ? $5ad41d0ab9107ecf$export$9fec4d97f1922e0b(node, "style") : value;
    const nodeStyle = node.style;
    if (typeof value === "string") return nodeStyle.cssText = value;
    typeof prev === "string" && (nodeStyle.cssText = prev = undefined);
    prev || (prev = {});
    value || (value = {});
    let v, s;
    for(s in prev){
        value[s] == null && nodeStyle.removeProperty(s);
        delete prev[s];
    }
    for(s in value){
        v = value[s];
        if (v !== prev[s]) {
            nodeStyle.setProperty(s, v);
            prev[s] = v;
        }
    }
    return prev;
}
function $5ad41d0ab9107ecf$export$3ae0fd4797ed47c8(node, props = {}, isSVG, skipChildren) {
    const prevProps = {};
    if (!skipChildren) (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)(()=>prevProps.children = $5ad41d0ab9107ecf$var$insertExpression(node, props.children, prevProps.children));
    (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)(()=>typeof props.ref === "function" && $5ad41d0ab9107ecf$export$1f96ae73734a86cc(props.ref, node));
    (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)(()=>$5ad41d0ab9107ecf$export$e6e34fd1f2686227(node, props, isSVG, true, prevProps, true));
    return prevProps;
}
function $5ad41d0ab9107ecf$export$2810486c22c942e9(props, key) {
    const src = props[key];
    Object.defineProperty(props, key, {
        get () {
            return src();
        },
        enumerable: true
    });
    return props;
}
function $5ad41d0ab9107ecf$export$1f96ae73734a86cc(fn, element, arg) {
    return (0, $44b2e6cc5a4c09f8$export$363ebc4b78b8f807)(()=>fn(element, arg));
}
function $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff(parent, accessor, marker, initial) {
    if (marker !== undefined && !initial) initial = [];
    if (typeof accessor !== "function") return $5ad41d0ab9107ecf$var$insertExpression(parent, accessor, initial, marker);
    (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)((current)=>$5ad41d0ab9107ecf$var$insertExpression(parent, accessor(), current, marker), initial);
}
function $5ad41d0ab9107ecf$export$e6e34fd1f2686227(node, props, isSVG, skipChildren, prevProps = {}, skipRef = false) {
    props || (props = {});
    for(const prop in prevProps)if (!(prop in props)) {
        if (prop === "children") continue;
        prevProps[prop] = $5ad41d0ab9107ecf$var$assignProp(node, prop, null, prevProps[prop], isSVG, skipRef, props);
    }
    for(const prop in props){
        if (prop === "children") {
            if (!skipChildren) $5ad41d0ab9107ecf$var$insertExpression(node, props.children);
            continue;
        }
        const value = props[prop];
        prevProps[prop] = $5ad41d0ab9107ecf$var$assignProp(node, prop, value, prevProps[prop], isSVG, skipRef, props);
    }
}
function $5ad41d0ab9107ecf$var$hydrate$1(code, element, options = {}) {
    if (globalThis._$HY.done) return $5ad41d0ab9107ecf$export$b3890eb0ae9dca99(code, element, [
        ...element.childNodes
    ], options);
    (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).completed = globalThis._$HY.completed;
    (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).events = globalThis._$HY.events;
    (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).load = (id)=>globalThis._$HY.r[id];
    (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).has = (id)=>id in globalThis._$HY.r;
    (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).gather = (root)=>$5ad41d0ab9107ecf$var$gatherHydratable(element, root);
    (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).registry = new Map();
    (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).context = {
        id: options.renderId || "",
        count: 0
    };
    try {
        $5ad41d0ab9107ecf$var$gatherHydratable(element, options.renderId);
        return $5ad41d0ab9107ecf$export$b3890eb0ae9dca99(code, element, [
            ...element.childNodes
        ], options);
    } finally{
        (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).context = null;
    }
}
function $5ad41d0ab9107ecf$export$4109ed81edd7716d(template) {
    let node, key, hydrating = $5ad41d0ab9107ecf$var$isHydrating();
    if (!hydrating || !(node = (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).registry.get(key = $5ad41d0ab9107ecf$export$a5a9dff0691837de()))) return template();
    if ((0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).completed) (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).completed.add(node);
    (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).registry.delete(key);
    return node;
}
function $5ad41d0ab9107ecf$export$c19731b2c49ee4c9(el, nodeName) {
    while(el && el.localName !== nodeName)el = el.nextSibling;
    return el;
}
function $5ad41d0ab9107ecf$export$5cf9b6f37b7c0802(start) {
    let end = start, count = 0, current = [];
    if ($5ad41d0ab9107ecf$var$isHydrating(start)) while(end){
        if (end.nodeType === 8) {
            const v = end.nodeValue;
            if (v === "$") count++;
            else if (v === "/") {
                if (count === 0) return [
                    end,
                    current
                ];
                count--;
            }
        }
        current.push(end);
        end = end.nextSibling;
    }
    return [
        end,
        current
    ];
}
function $5ad41d0ab9107ecf$export$6fef5763b6d3688d() {
    if ((0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).events && !(0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).events.queued) {
        queueMicrotask(()=>{
            const { completed: completed, events: events } = (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027);
            if (!events) return;
            events.queued = false;
            while(events.length){
                const [el, e] = events[0];
                if (!completed.has(el)) return;
                events.shift();
                $5ad41d0ab9107ecf$var$eventHandler(e);
            }
            if ((0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).done) {
                (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).events = _$HY.events = null;
                (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).completed = _$HY.completed = null;
            }
        });
        (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).events.queued = true;
    }
}
function $5ad41d0ab9107ecf$var$isHydrating(node) {
    return !!(0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).context && !(0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).done && (!node || node.isConnected);
}
function $5ad41d0ab9107ecf$var$toPropertyName(name) {
    return name.toLowerCase().replace(/-([a-z])/g, (_, w)=>w.toUpperCase());
}
function $5ad41d0ab9107ecf$var$toggleClassKey(node, key, value) {
    const classNames = key.trim().split(/\s+/);
    for(let i = 0, nameLen = classNames.length; i < nameLen; i++)node.classList.toggle(classNames[i], value);
}
function $5ad41d0ab9107ecf$var$assignProp(node, prop, value, prev, isSVG, skipRef, props) {
    let isCE, isProp, isChildProp, propAlias, forceProp;
    if (prop === "style") return $5ad41d0ab9107ecf$export$1d567c320f4763bc(node, value, prev);
    if (prop === "classList") return $5ad41d0ab9107ecf$export$11c615ce16f87241(node, value, prev);
    if (value === prev) return prev;
    if (prop === "ref") {
        if (!skipRef) value(node);
    } else if (prop.slice(0, 3) === "on:") {
        const e = prop.slice(3);
        prev && node.removeEventListener(e, prev, typeof prev !== "function" && prev);
        value && node.addEventListener(e, value, typeof value !== "function" && value);
    } else if (prop.slice(0, 10) === "oncapture:") {
        const e = prop.slice(10);
        prev && node.removeEventListener(e, prev, true);
        value && node.addEventListener(e, value, true);
    } else if (prop.slice(0, 2) === "on") {
        const name = prop.slice(2).toLowerCase();
        const delegate = $5ad41d0ab9107ecf$export$389d7c657d123a81.has(name);
        if (!delegate && prev) {
            const h = Array.isArray(prev) ? prev[0] : prev;
            node.removeEventListener(name, h);
        }
        if (delegate || value) {
            $5ad41d0ab9107ecf$export$3f65cefe8380dbea(node, name, value, delegate);
            delegate && $5ad41d0ab9107ecf$export$ad0f7f87f67e17d6([
                name
            ]);
        }
    } else if (prop.slice(0, 5) === "attr:") $5ad41d0ab9107ecf$export$9fec4d97f1922e0b(node, prop.slice(5), value);
    else if (prop.slice(0, 5) === "bool:") $5ad41d0ab9107ecf$export$248913d9a30bef7a(node, prop.slice(5), value);
    else if ((forceProp = prop.slice(0, 5) === "prop:") || (isChildProp = $5ad41d0ab9107ecf$export$2c72a9edec54d5d9.has(prop)) || !isSVG && ((propAlias = $5ad41d0ab9107ecf$export$72dcdd3761a309a9(prop, node.tagName)) || (isProp = $5ad41d0ab9107ecf$export$8714badcfa4caafb.has(prop))) || (isCE = node.nodeName.includes("-") || "is" in props)) {
        if (forceProp) {
            prop = prop.slice(5);
            isProp = true;
        } else if ($5ad41d0ab9107ecf$var$isHydrating(node)) return value;
        if (prop === "class" || prop === "className") $5ad41d0ab9107ecf$export$2913c0c0b5623090(node, value);
        else if (isCE && !isProp && !isChildProp) node[$5ad41d0ab9107ecf$var$toPropertyName(prop)] = value;
        else node[propAlias || prop] = value;
    } else {
        const ns = isSVG && prop.indexOf(":") > -1 && $5ad41d0ab9107ecf$export$fa927d1d0495a67d[prop.split(":")[0]];
        if (ns) $5ad41d0ab9107ecf$export$75900142c9e21800(node, ns, prop, value);
        else $5ad41d0ab9107ecf$export$9fec4d97f1922e0b(node, $5ad41d0ab9107ecf$export$8915b7db7f70cfed[prop] || prop, value);
    }
    return value;
}
function $5ad41d0ab9107ecf$var$eventHandler(e) {
    if ((0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).registry && (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).events) {
        if ((0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).events.find(([el, ev])=>ev === e)) return;
    }
    let node = e.target;
    const key = `$$${e.type}`;
    const oriTarget = e.target;
    const oriCurrentTarget = e.currentTarget;
    const retarget = (value)=>Object.defineProperty(e, "target", {
            configurable: true,
            value: value
        });
    const handleNode = ()=>{
        const handler = node[key];
        if (handler && !node.disabled) {
            const data = node[`${key}Data`];
            data !== undefined ? handler.call(node, data, e) : handler.call(node, e);
            if (e.cancelBubble) return;
        }
        node.host && typeof node.host !== "string" && !node.host._$host && node.contains(e.target) && retarget(node.host);
        return true;
    };
    const walkUpTree = ()=>{
        while(handleNode() && (node = node._$host || node.parentNode || node.host));
    };
    Object.defineProperty(e, "currentTarget", {
        configurable: true,
        get () {
            return node || document;
        }
    });
    if ((0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).registry && !(0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).done) (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).done = _$HY.done = true;
    if (e.composedPath) {
        const path = e.composedPath();
        retarget(path[0]);
        for(let i = 0; i < path.length - 2; i++){
            node = path[i];
            if (!handleNode()) break;
            if (node._$host) {
                node = node._$host;
                walkUpTree();
                break;
            }
            if (node.parentNode === oriCurrentTarget) break;
        }
    } else walkUpTree();
    retarget(oriTarget);
}
function $5ad41d0ab9107ecf$var$insertExpression(parent, value, current, marker, unwrapArray) {
    const hydrating = $5ad41d0ab9107ecf$var$isHydrating(parent);
    if (hydrating) {
        !current && (current = [
            ...parent.childNodes
        ]);
        let cleaned = [];
        for(let i = 0; i < current.length; i++){
            const node = current[i];
            if (node.nodeType === 8 && node.data.slice(0, 2) === "!$") node.remove();
            else cleaned.push(node);
        }
        current = cleaned;
    }
    while(typeof current === "function")current = current();
    if (value === current) return current;
    const t = typeof value, multi = marker !== undefined;
    parent = multi && current[0] && current[0].parentNode || parent;
    if (t === "string" || t === "number") {
        if (hydrating) return current;
        if (t === "number") {
            value = value.toString();
            if (value === current) return current;
        }
        if (multi) {
            let node = current[0];
            if (node && node.nodeType === 3) node.data !== value && (node.data = value);
            else node = document.createTextNode(value);
            current = $5ad41d0ab9107ecf$var$cleanChildren(parent, current, marker, node);
        } else if (current !== "" && typeof current === "string") current = parent.firstChild.data = value;
        else current = parent.textContent = value;
    } else if (value == null || t === "boolean") {
        if (hydrating) return current;
        current = $5ad41d0ab9107ecf$var$cleanChildren(parent, current, marker);
    } else if (t === "function") {
        (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)(()=>{
            let v = value();
            while(typeof v === "function")v = v();
            current = $5ad41d0ab9107ecf$var$insertExpression(parent, v, current, marker);
        });
        return ()=>current;
    } else if (Array.isArray(value)) {
        const array = [];
        const currentArray = current && Array.isArray(current);
        if ($5ad41d0ab9107ecf$var$normalizeIncomingArray(array, value, current, unwrapArray)) {
            (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)(()=>current = $5ad41d0ab9107ecf$var$insertExpression(parent, array, current, marker, true));
            return ()=>current;
        }
        if (hydrating) {
            if (!array.length) return current;
            if (marker === undefined) return current = [
                ...parent.childNodes
            ];
            let node = array[0];
            if (node.parentNode !== parent) return current;
            const nodes = [
                node
            ];
            while((node = node.nextSibling) !== marker)nodes.push(node);
            return current = nodes;
        }
        if (array.length === 0) {
            current = $5ad41d0ab9107ecf$var$cleanChildren(parent, current, marker);
            if (multi) return current;
        } else if (currentArray) {
            if (current.length === 0) $5ad41d0ab9107ecf$var$appendNodes(parent, array, marker);
            else $5ad41d0ab9107ecf$var$reconcileArrays(parent, current, array);
        } else {
            current && $5ad41d0ab9107ecf$var$cleanChildren(parent);
            $5ad41d0ab9107ecf$var$appendNodes(parent, array);
        }
        current = array;
    } else if (value.nodeType) {
        if (hydrating && value.parentNode) return current = multi ? [
            value
        ] : value;
        if (Array.isArray(current)) {
            if (multi) return current = $5ad41d0ab9107ecf$var$cleanChildren(parent, current, marker, value);
            $5ad41d0ab9107ecf$var$cleanChildren(parent, current, null, value);
        } else if (current == null || current === "" || !parent.firstChild) parent.appendChild(value);
        else parent.replaceChild(value, parent.firstChild);
        current = value;
    }
    return current;
}
function $5ad41d0ab9107ecf$var$normalizeIncomingArray(normalized, array, current, unwrap) {
    let dynamic = false;
    for(let i = 0, len = array.length; i < len; i++){
        let item = array[i], prev = current && current[normalized.length], t;
        if (item == null || item === true || item === false) ;
        else if ((t = typeof item) === "object" && item.nodeType) normalized.push(item);
        else if (Array.isArray(item)) dynamic = $5ad41d0ab9107ecf$var$normalizeIncomingArray(normalized, item, prev) || dynamic;
        else if (t === "function") {
            if (unwrap) {
                while(typeof item === "function")item = item();
                dynamic = $5ad41d0ab9107ecf$var$normalizeIncomingArray(normalized, Array.isArray(item) ? item : [
                    item
                ], Array.isArray(prev) ? prev : [
                    prev
                ]) || dynamic;
            } else {
                normalized.push(item);
                dynamic = true;
            }
        } else {
            const value = String(item);
            if (prev && prev.nodeType === 3 && prev.data === value) normalized.push(prev);
            else normalized.push(document.createTextNode(value));
        }
    }
    return dynamic;
}
function $5ad41d0ab9107ecf$var$appendNodes(parent, array, marker = null) {
    for(let i = 0, len = array.length; i < len; i++)parent.insertBefore(array[i], marker);
}
function $5ad41d0ab9107ecf$var$cleanChildren(parent, current, marker, replacement) {
    if (marker === undefined) return parent.textContent = "";
    const node = replacement || document.createTextNode("");
    if (current.length) {
        let inserted = false;
        for(let i = current.length - 1; i >= 0; i--){
            const el = current[i];
            if (node !== el) {
                const isParent = el.parentNode === parent;
                if (!inserted && !i) isParent ? parent.replaceChild(node, el) : parent.insertBefore(node, marker);
                else isParent && el.remove();
            } else inserted = true;
        }
    } else parent.insertBefore(node, marker);
    return [
        node
    ];
}
function $5ad41d0ab9107ecf$var$gatherHydratable(element, root) {
    const templates = element.querySelectorAll(`*[data-hk]`);
    for(let i = 0; i < templates.length; i++){
        const node = templates[i];
        const key = node.getAttribute("data-hk");
        if ((!root || key.startsWith(root)) && !(0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).registry.has(key)) (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).registry.set(key, node);
    }
}
function $5ad41d0ab9107ecf$export$a5a9dff0691837de() {
    return (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).getNextContextId();
}
function $5ad41d0ab9107ecf$export$36143b7c9c07dd39(props) {
    return (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).context ? undefined : props.children;
}
function $5ad41d0ab9107ecf$export$da8cca6e5dfa3577(props) {
    return props.children;
}
const $5ad41d0ab9107ecf$export$c8eca95e306f7116 = ()=>undefined;
const $5ad41d0ab9107ecf$export$5df49ba75ba1c1f9 = Symbol();
function $5ad41d0ab9107ecf$export$8bd3fff6c675ca8d(parent, content) {
    !(0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).context && (parent.innerHTML = content);
}
function $5ad41d0ab9107ecf$var$throwInBrowser(func) {
    const err = new Error(`${func.name} is not supported in the browser, returning undefined`);
    console.error(err);
}
function $5ad41d0ab9107ecf$export$80e7718417253a51(fn, options) {
    $5ad41d0ab9107ecf$var$throwInBrowser($5ad41d0ab9107ecf$export$80e7718417253a51);
}
function $5ad41d0ab9107ecf$export$f3aefc4196cd5f3e(fn, options) {
    $5ad41d0ab9107ecf$var$throwInBrowser($5ad41d0ab9107ecf$export$f3aefc4196cd5f3e);
}
function $5ad41d0ab9107ecf$export$97f86213fef5749d(fn, options) {
    $5ad41d0ab9107ecf$var$throwInBrowser($5ad41d0ab9107ecf$export$97f86213fef5749d);
}
function $5ad41d0ab9107ecf$export$ea2375f6c0c9ffdc(template, ...nodes) {}
function $5ad41d0ab9107ecf$export$1844beb7faeb4553(name, props, children, needsId) {}
function $5ad41d0ab9107ecf$export$e92e0c287593a882(value) {}
function $5ad41d0ab9107ecf$export$9e97f11b9d683d7a(value) {}
function $5ad41d0ab9107ecf$export$9ab8bdc1e27e51e1(key, value) {}
function $5ad41d0ab9107ecf$export$7e66a08c0b8ab2aa() {}
function $5ad41d0ab9107ecf$export$755e9f954b4fd36e(node) {}
function $5ad41d0ab9107ecf$export$4e7f196112fea3c5(html) {}
function $5ad41d0ab9107ecf$export$8c2b042ce8153017(props, isSVG, skipChildren) {}
const $5ad41d0ab9107ecf$export$6acf61af03e62db = false;
const $5ad41d0ab9107ecf$export$40edfb7eeb78c4e8 = false;
const $5ad41d0ab9107ecf$var$SVG_NAMESPACE = "http://www.w3.org/2000/svg";
function $5ad41d0ab9107ecf$var$createElement(tagName, isSVG = false) {
    return isSVG ? document.createElementNS($5ad41d0ab9107ecf$var$SVG_NAMESPACE, tagName) : document.createElement(tagName);
}
const $5ad41d0ab9107ecf$export$fa8d919ba61d84db = (...args)=>{
    (0, $44b2e6cc5a4c09f8$export$849801d35d2160c9)();
    return $5ad41d0ab9107ecf$var$hydrate$1(...args);
};
function $5ad41d0ab9107ecf$export$602eac185826482c(props) {
    const { useShadow: useShadow } = props, marker = document.createTextNode(""), mount = ()=>props.mount || document.body, owner = (0, $44b2e6cc5a4c09f8$export$5f4ed0d56c2c0edf)();
    let content;
    let hydrating = !!(0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).context;
    (0, $44b2e6cc5a4c09f8$export$7ea7134f704deda4)(()=>{
        if (hydrating) (0, $44b2e6cc5a4c09f8$export$5f4ed0d56c2c0edf)().user = hydrating = false;
        content || (content = (0, $44b2e6cc5a4c09f8$export$c14f3e3abbc7d6b5)(owner, ()=>(0, $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa)(()=>props.children)));
        const el = mount();
        if (el instanceof HTMLHeadElement) {
            const [clean, setClean] = (0, $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5)(false);
            const cleanup = ()=>setClean(true);
            (0, $44b2e6cc5a4c09f8$export$882461b6382ed46c)((dispose)=>$5ad41d0ab9107ecf$export$21a5ca8aa77d35ff(el, ()=>!clean() ? content() : dispose(), null));
            (0, $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab)(cleanup);
        } else {
            const container = $5ad41d0ab9107ecf$var$createElement(props.isSVG ? "g" : "div", props.isSVG), renderRoot = useShadow && container.attachShadow ? container.attachShadow({
                mode: "open"
            }) : container;
            Object.defineProperty(container, "_$host", {
                get () {
                    return marker.parentNode;
                },
                configurable: true
            });
            $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff(renderRoot, content);
            el.appendChild(container);
            props.ref && props.ref(container);
            (0, $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab)(()=>el.removeChild(container));
        }
    }, undefined, {
        render: !hydrating
    });
    return marker;
}
function $5ad41d0ab9107ecf$export$9a3ff77bac07eb26(component, props) {
    const cached = (0, $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa)(component);
    return (0, $44b2e6cc5a4c09f8$export$c0c6c8b9c16bf6aa)(()=>{
        const component = cached();
        switch(typeof component){
            case "function":
                return (0, $44b2e6cc5a4c09f8$export$363ebc4b78b8f807)(()=>component(props));
            case "string":
                const isSvg = $5ad41d0ab9107ecf$export$ccaf9b9a82de4b98.has(component);
                const el = (0, $44b2e6cc5a4c09f8$export$2cb4986bed338027).context ? $5ad41d0ab9107ecf$export$4109ed81edd7716d() : $5ad41d0ab9107ecf$var$createElement(component, isSvg);
                $5ad41d0ab9107ecf$export$3ae0fd4797ed47c8(el, props, isSvg);
                return el;
        }
    });
}
function $5ad41d0ab9107ecf$export$e18282e419e46834(props) {
    const [, others] = (0, $44b2e6cc5a4c09f8$export$45029c61b0073d87)(props, [
        "component"
    ]);
    return $5ad41d0ab9107ecf$export$9a3ff77bac07eb26(()=>props.component, others);
}







var $28a8adbfaeaa730d$var$_tmpl$ = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<button type=button class="app-button app-button--secondary inline-flex min-h-[44px] w-full sm:w-auto sm:min-w-[140px] items-center justify-center rounded-lg border px-4 text-[13px] font-medium">`);
const $28a8adbfaeaa730d$export$301dd8b2c7787662 = 'app-button app-button--secondary inline-flex min-h-[44px] w-full sm:w-auto sm:min-w-[140px] items-center justify-center rounded-lg border px-4 text-[13px] font-medium';
function $28a8adbfaeaa730d$export$2e2bcd8739ae039(props) {
    return (()=>{
        var _el$ = $28a8adbfaeaa730d$var$_tmpl$();
        (0, $5ad41d0ab9107ecf$export$3f65cefe8380dbea)(_el$, "click", (e)=>props.onClick(e));
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$, ()=>props.label);
        (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)((_p$)=>{
            var _v$ = props.testId, _v$2 = props.disabled;
            _v$ !== _p$.e && (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$, "data-testid", _p$.e = _v$);
            _v$2 !== _p$.t && (_el$.disabled = _p$.t = _v$2);
            return _p$;
        }, {
            e: undefined,
            t: undefined
        });
        return _el$;
    })();
}


/**
 * FINAL cookie-consent copy: DesignBot, Cookie Consent Spec §4 (Nov 5, 2026).
 * Andrew-authorized to ship without DocsBot/legal sign-off. Use these strings exactly;
 * policy version / re-consent / Privacy Policy URL are in config.ts.
 *
 * Classification decisions (TuneDevBot, Nov 3 2026), reflected in the
 * "Strictly necessary" table below:
 * - Captcha (Cloudflare Turnstile / Google reCAPTCHA v3): necessary (security / bot protection).
 * - Sentry (processor: Functional Software, Inc. d/b/a Sentry): error monitoring is
 *   strictly necessary / legitimate interest (TuneDevBot decision). Sentry.init runs
 *   before consent for error reporting ONLY: sendDefaultPii false, no IP stored
 *   (user.ip_address null, request headers/cookies/query removed, URL queries dropped),
 *   user id only, no console/DOM breadcrumbs (utils/sentry-privacy.ts). Session Replay,
 *   tracing (performance monitoring) and UI/console breadcrumbs run only after
 *   ANALYTICS consent (sentry-replay.ts). Region/retention: PENDING (see the Personal
 *   Data Inventory row "Sentry (web front end)").
 * - Device fingerprint (TF_SECFP): necessary only when used for fraud/security.
 *   Finding: apiv1/fingerprint.py + fingerprint_service.py use it for login/register
 *   bot detection and replay-protected attestation; admin uses ProfileFingerPrint to
 *   flag/deactivate linked suspicious accounts (BOT_FINGERPRINT). No analytics/ads use
 *   was found, so it is listed as necessary (security).
 */ const $e0c366c0458a196e$export$92f9e1ed9114d3a6 = {
    bannerTitle: 'We value your privacy',
    bannerBody: 'We use strictly necessary cookies to run Tune.fm. With your permission, we also use optional cookies for analytics (Google Analytics 4) and marketing (tags fired by Google Tag Manager). You can Accept all, Reject all, or Customize by category. You can change your choices anytime via Cookie settings.',
    /** banner body links: "Cookie settings" opens the preferences modal; "Privacy Policy" -> privacy_policy_url */ settingsLink: 'Cookie settings',
    privacyLink: 'Privacy Policy',
    rejectAll: 'Reject all',
    customize: 'Customize',
    acceptAll: 'Accept all',
    saveChoices: 'Save choices',
    modalTitle: 'Cookie preferences',
    modalIntro: 'Choose which optional cookies Tune.fm may use. Strictly necessary cookies stay on because the service cannot work without them. Your choices are stored for 12 months, or until we change this policy.',
    closeLabel: 'Close cookie preferences',
    saved: 'Your cookie preferences were saved.',
    saveError: "We couldn't save your preferences. Try again.",
    youtubeNote: 'Playing this video loads YouTube. Continuing plays the video and allows YouTube to set cookies for that playback.',
    ccpaLink: 'Do Not Sell or Share My Personal Information',
    alwaysOn: 'Always on',
    viewCookies: 'View cookies',
    gpc: "We honored your browser's Global Privacy Control signal. Marketing cookies stay off.",
    gpcLocked: '(Off: Global Privacy Control)'
};
const $e0c366c0458a196e$export$a513ea61a7bee91c = [
    {
        id: 'necessary',
        label: 'Strictly necessary',
        description: 'Required for security, sign-in, fraud prevention, consent storage, and core fonts (including Adobe Fonts). If Adobe Fonts cannot load, we fall back to system fonts. These cannot be turned off.',
        cookies: [
            {
                name: 'sessionid',
                provider: 'Tune.fm',
                purpose: 'Keeps you signed in',
                duration: 'Session / 2 weeks'
            },
            {
                name: 'csrftoken',
                provider: 'Tune.fm',
                purpose: 'Protects forms against forgery',
                duration: '1 year'
            },
            {
                name: 'tune_consent',
                provider: 'Tune.fm',
                purpose: 'Stores your cookie choices',
                duration: '12 months'
            },
            {
                name: 'TF_SECFP',
                provider: 'Tune.fm',
                purpose: 'Device check for fraud and bot protection at sign-in',
                duration: 'TBD'
            },
            {
                name: 'Turnstile / reCAPTCHA',
                provider: 'Cloudflare / Google',
                purpose: 'Bot protection on forms (captcha)',
                duration: 'Session / TBD'
            },
            {
                name: 'Adobe Fonts / Typekit (no cookies)',
                provider: 'Adobe',
                purpose: 'Core fonts: loads the landing page web fonts from use.typekit.net; Adobe logs a page view (p.typekit.net) for font licensing. System fonts are used if it cannot load',
                duration: 'n/a'
            },
            {
                name: 'Sentry error monitoring (no cookies)',
                provider: 'Functional Software, Inc. (Sentry), processor',
                purpose: 'Error monitoring: error details, user id, browser/OS and page URL without query; no IP address, no session replay. Legal basis: legitimate interest (strictly necessary)',
                duration: 'n/a (events kept per Sentry retention, TBD)'
            }
        ]
    },
    {
        id: 'analytics',
        label: 'Analytics',
        description: 'Helps us understand how Tune.fm is used via Google Analytics 4 (GA4 measurement ID G-6689026RCH). Includes product analytics and Sentry Session Replay / tracing when enabled. Off until you opt in.',
        cookies: [
            {
                name: '_ga, _ga_*',
                provider: 'Google',
                purpose: 'Distinguishes visitors and sessions',
                duration: 'Up to 14 months'
            },
            {
                name: 'Sentry Session Replay (sessionStorage)',
                provider: 'Functional Software, Inc. (Sentry), processor',
                purpose: 'Records page interactions to debug errors (media blocked). Only with analytics consent',
                duration: 'Session'
            },
            {
                name: 'Sentry performance tracing and UI/console breadcrumbs (no cookies)',
                provider: 'Functional Software, Inc. (Sentry), processor',
                purpose: 'Page-load and request timings, clicks and console messages attached to error reports. Only with analytics consent',
                duration: 'n/a'
            }
        ]
    },
    {
        id: 'marketing',
        label: 'Marketing',
        description: 'Lets Google Tag Manager (GTM-W5LBRNP4) fire advertising and attribution tags (for example ad pixels). Off until you opt in. When Global Privacy Control (GPC) is on, marketing stays off.',
        cookies: [
            {
                name: 'TBD (GTM container audit)',
                provider: 'Google / third parties',
                purpose: 'Ads measurement',
                duration: 'TBD'
            }
        ]
    }
];


var $df74a03f26d92cab$var$_tmpl$ = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<p data-testid=consent-gpc-notice class="m-0 mt-2 text-[12px] text-[color:var(--tc-success)]">`), $df74a03f26d92cab$var$_tmpl$2 = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<section role=region aria-labelledby=consent-title data-testid=consent-banner class="tc-bottom fixed inset-x-0 px-4 md:px-6"><div class="mx-auto flex max-w-[1200px] flex-col gap-4 rounded-xl border border-[color:var(--tc-border)] bg-[var(--tc-surface)] p-4 text-[color:var(--tc-text)] shadow-2xl md:p-5 lg:flex-row lg:items-center lg:justify-between"><div class=min-w-0><h2 id=consent-title class="m-0 text-base font-semibold"></h2><p class="m-0 mt-1 text-sm text-[color:var(--tc-text-2)]"> <a href=#cookie-settings data-testid=consent-banner-settings class="underline text-[color:var(--tc-accent)]"></a> \xb7 <a target=_blank rel=noopener data-testid=consent-privacy-link class="underline text-[color:var(--tc-accent)]"></a> \xb7 <a href=#do-not-sell data-testid=consent-banner-dns class="underline text-[color:var(--tc-accent)]"></a></p></div><div class="flex flex-col gap-2 sm:flex-row sm:gap-3 lg:shrink-0"data-testid=consent-banner-actions>`);
function $df74a03f26d92cab$export$2e2bcd8739ae039(props) {
    return (()=>{
        var _el$ = $df74a03f26d92cab$var$_tmpl$2(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$5.firstChild, _el$7 = _el$6.nextSibling, _el$8 = _el$7.nextSibling, _el$9 = _el$8.nextSibling, _el$0 = _el$9.nextSibling, _el$1 = _el$0.nextSibling, _el$11 = _el$3.nextSibling;
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$4, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).bannerTitle);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$5, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).bannerBody, _el$6);
        _el$7.$$click = (e)=>{
            e.preventDefault();
            props.onCustomize(e);
        };
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$7, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).settingsLink);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$9, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).privacyLink);
        _el$1.$$click = (e)=>{
            e.preventDefault();
            if (!props.busy) props.onDoNotSell();
        };
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$1, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).ccpaLink);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$3, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $44b2e6cc5a4c09f8$export$f6a3d19be20f5819), {
            get when () {
                return props.gpc;
            },
            get children () {
                var _el$10 = $df74a03f26d92cab$var$_tmpl$();
                (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$10, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).gpc);
                return _el$10;
            }
        }), null);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$11, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $28a8adbfaeaa730d$export$2e2bcd8739ae039), {
            get label () {
                return (0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).rejectAll;
            },
            testId: "consent-reject",
            get disabled () {
                return props.busy;
            },
            get onClick () {
                return props.onReject;
            }
        }), null);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$11, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $28a8adbfaeaa730d$export$2e2bcd8739ae039), {
            get label () {
                return (0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).customize;
            },
            testId: "consent-customize",
            get disabled () {
                return props.busy;
            },
            get onClick () {
                return props.onCustomize;
            }
        }), null);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$11, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $28a8adbfaeaa730d$export$2e2bcd8739ae039), {
            get label () {
                return (0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).acceptAll;
            },
            testId: "consent-accept",
            get disabled () {
                return props.busy;
            },
            get onClick () {
                return props.onAccept;
            }
        }), null);
        (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)((_p$)=>{
            var _v$ = props.busy ? 'true' : 'false', _v$2 = props.privacyUrl, _v$3 = props.busy ? 'true' : undefined;
            _v$ !== _p$.e && (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$, "aria-busy", _p$.e = _v$);
            _v$2 !== _p$.t && (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$9, "href", _p$.t = _v$2);
            _v$3 !== _p$.a && (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$1, "aria-disabled", _p$.a = _v$3);
            return _p$;
        }, {
            e: undefined,
            t: undefined,
            a: undefined
        });
        return _el$;
    })();
}
(0, $5ad41d0ab9107ecf$export$ad0f7f87f67e17d6)([
    "click"
]);








var $0d36ad8713908dd0$var$_tmpl$ = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<input type=checkbox role=switch>`);
function $0d36ad8713908dd0$export$2e2bcd8739ae039(props) {
    return (()=>{
        var _el$ = $0d36ad8713908dd0$var$_tmpl$();
        (0, $5ad41d0ab9107ecf$export$3f65cefe8380dbea)(_el$, "change", (e)=>props.onChange?.(e.currentTarget.checked));
        (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)((_p$)=>{
            var _v$ = props.id, _v$2 = `tc-switch ${props.locked || props.forcedOff ? 'opacity-70 cursor-not-allowed' : 'cursor-pointer'}`, _v$3 = `consent-switch-${props.id}`, _v$4 = props.locked || props.forcedOff, _v$5 = props.locked ? 'true' : !props.forcedOff && props.checked ? 'true' : 'false', _v$6 = props.describedBy;
            _v$ !== _p$.e && (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$, "id", _p$.e = _v$);
            _v$2 !== _p$.t && (0, $5ad41d0ab9107ecf$export$2913c0c0b5623090)(_el$, _p$.t = _v$2);
            _v$3 !== _p$.a && (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$, "data-testid", _p$.a = _v$3);
            _v$4 !== _p$.o && (_el$.disabled = _p$.o = _v$4);
            _v$5 !== _p$.i && (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$, "aria-checked", _p$.i = _v$5);
            _v$6 !== _p$.n && (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$, "aria-describedby", _p$.n = _v$6);
            return _p$;
        }, {
            e: undefined,
            t: undefined,
            a: undefined,
            o: undefined,
            i: undefined,
            n: undefined
        });
        (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)(()=>_el$.checked = props.locked ? true : props.forcedOff ? false : props.checked);
        return _el$;
    })();
}



var $b1dc0be175d212eb$var$_tmpl$ = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<div class="border-t border-[color:var(--tc-border-soft)] py-3"><div class="flex items-start justify-between gap-4"><div class=min-w-0><label class="block text-[14px] font-semibold text-[color:var(--tc-text)]"></label><p class="m-0 mt-1 text-[12px] text-[color:var(--tc-text-2)]"></p></div></div><details class=mt-2><summary class="cursor-pointer text-[12px] text-[color:var(--tc-accent)]"></summary><div class=overflow-x-auto><table class="mt-2 w-full text-left text-[12px] text-[color:var(--tc-text-2)]"><thead><tr><th class="py-1 pr-3 font-semibold">Name</th><th class="py-1 pr-3 font-semibold">Provider</th><th class="py-1 pr-3 font-semibold">Purpose</th><th class="py-1 font-semibold">Duration</th></tr></thead><tbody>`), $b1dc0be175d212eb$var$_tmpl$2 = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<span class="ml-1 font-semibold text-[color:var(--tc-success)]">`), $b1dc0be175d212eb$var$_tmpl$3 = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<span data-testid=consent-gpc-locked class="ml-1 font-semibold text-[color:var(--tc-success)]">`), $b1dc0be175d212eb$var$_tmpl$4 = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<tr class="border-t border-[color:var(--tc-border-soft)]"><td class="py-1 pr-3 break-all"></td><td class="py-1 pr-3"></td><td class="py-1 pr-3"></td><td class=py-1>`);
function $b1dc0be175d212eb$export$2e2bcd8739ae039(props) {
    const c = props.category;
    const sw = `tc-${c.id}`;
    const desc = `tc-${c.id}-desc`;
    const locked = c.id === 'necessary';
    return (()=>{
        var _el$ = $b1dc0be175d212eb$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$2.nextSibling, _el$7 = _el$6.firstChild, _el$8 = _el$7.nextSibling, _el$9 = _el$8.firstChild, _el$0 = _el$9.firstChild, _el$1 = _el$0.nextSibling;
        (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$4, "for", sw);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$4, ()=>c.label);
        (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$5, "id", desc);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$5, ()=>c.description, null);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$5, locked ? (()=>{
            var _el$10 = $b1dc0be175d212eb$var$_tmpl$2();
            (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$10, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).alwaysOn);
            return _el$10;
        })() : null, null);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$5, (()=>{
            var _c$ = (0, $5ad41d0ab9107ecf$export$7c73462e0d25e514)(()=>!!props.gpcLocked);
            return ()=>_c$() ? (()=>{
                    var _el$11 = $b1dc0be175d212eb$var$_tmpl$3();
                    (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$11, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).gpcLocked);
                    return _el$11;
                })() : null;
        })(), null);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$2, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $0d36ad8713908dd0$export$2e2bcd8739ae039), {
            id: sw,
            get checked () {
                return props.checked;
            },
            locked: locked,
            get forcedOff () {
                return props.gpcLocked;
            },
            describedBy: desc,
            get onChange () {
                return props.onChange;
            }
        }), null);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$7, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).viewCookies);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$1, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $44b2e6cc5a4c09f8$export$bdf530073099ce9f), {
            get each () {
                return c.cookies;
            },
            children: (k)=>(()=>{
                    var _el$12 = $b1dc0be175d212eb$var$_tmpl$4(), _el$13 = _el$12.firstChild, _el$14 = _el$13.nextSibling, _el$15 = _el$14.nextSibling, _el$16 = _el$15.nextSibling;
                    (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$13, ()=>k.name);
                    (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$14, ()=>k.provider);
                    (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$15, ()=>k.purpose);
                    (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$16, ()=>k.duration);
                    return _el$12;
                })()
        }));
        (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)(()=>(0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$, "data-testid", `consent-row-${c.id}`));
        return _el$;
    })();
}



var $56183baabcc2a64f$var$_tmpl$ = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<p data-testid=consent-gpc-notice-modal class="m-0 mb-2 text-[12px] text-[color:var(--tc-success)]">`), $56183baabcc2a64f$var$_tmpl$2 = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<div class="tc-modal-layer fixed inset-0 flex items-end justify-center bg-black/60 sm:items-center"data-testid=consent-modal><div role=dialog aria-modal=true aria-labelledby=consent-modal-title aria-describedby=consent-modal-intro class="fixed inset-0 flex flex-col bg-[var(--tc-surface)] text-[color:var(--tc-text)] sm:relative sm:inset-auto sm:max-h-[85vh] sm:w-full sm:max-w-[560px] sm:rounded-xl sm:border sm:border-[color:var(--tc-border)]"><div class="flex items-start justify-between gap-4 p-4 md:p-5"><h2 id=consent-modal-title tabindex=-1 class="m-0 text-base font-semibold outline-none"></h2><button type=button data-testid=consent-close class="tc-close inline-flex h-[44px] w-[44px] items-center justify-center rounded-lg text-[color:var(--tc-text-2)]"><svg aria-hidden=true width=16 height=16 viewBox="0 0 16 16"fill=none stroke=currentColor stroke-width=2 stroke-linecap=round><path d="M3 3l10 10M13 3L3 13"></path></svg></button></div><div class="flex-1 overflow-y-auto px-4 md:px-5"><p id=consent-modal-intro class="m-0 mb-2 text-sm text-[color:var(--tc-text-2)]"></p><fieldset class="m-0 border-0 p-0"><legend class=sr-only></legend></fieldset></div><div class="sticky bottom-0 grid grid-cols-1 gap-2 border-t border-[color:var(--tc-border-soft)] bg-[var(--tc-surface)] p-4 pt-4 sm:grid-cols-3 md:p-5">`);
const $56183baabcc2a64f$var$FOCUSABLE = 'button:not([disabled]), [href], input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
function $56183baabcc2a64f$export$2e2bcd8739ae039(props) {
    const [analytics, setAnalytics] = (0, $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5)(props.initial.analytics);
    const [marketing, setMarketing] = (0, $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5)(props.initial.marketing && !props.gpc);
    let dialog;
    let heading;
    const onKey = (e)=>{
        if (e.key === 'Escape') {
            // dismiss without change; never treated as consent
            e.preventDefault();
            props.onClose();
            return;
        }
        if (e.key !== 'Tab' || !dialog) return;
        const items = [
            ...dialog.querySelectorAll($56183baabcc2a64f$var$FOCUSABLE)
        ];
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        const active = props.root.activeElement;
        if (e.shiftKey && (active === first || active === heading)) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && active === last) {
            e.preventDefault();
            first.focus();
        }
    };
    (0, $44b2e6cc5a4c09f8$export$1e848a9e87980bd5)(()=>heading?.focus());
    (0, $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab)(()=>{});
    return (()=>{
        var _el$ = $56183baabcc2a64f$var$_tmpl$2(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$3.nextSibling, _el$7 = _el$6.firstChild, _el$9 = _el$7.nextSibling, _el$0 = _el$9.firstChild, _el$1 = _el$6.nextSibling;
        (0, $5ad41d0ab9107ecf$export$3f65cefe8380dbea)(_el$2, "keydown", onKey);
        var _ref$ = dialog;
        typeof _ref$ === "function" ? (0, $5ad41d0ab9107ecf$export$1f96ae73734a86cc)(_ref$, _el$2) : dialog = _el$2;
        var _ref$2 = heading;
        typeof _ref$2 === "function" ? (0, $5ad41d0ab9107ecf$export$1f96ae73734a86cc)(_ref$2, _el$4) : heading = _el$4;
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$4, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).modalTitle);
        (0, $5ad41d0ab9107ecf$export$3f65cefe8380dbea)(_el$5, "click", ()=>props.onClose());
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$7, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).modalIntro);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$6, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $44b2e6cc5a4c09f8$export$f6a3d19be20f5819), {
            get when () {
                return props.gpc;
            },
            get children () {
                var _el$8 = $56183baabcc2a64f$var$_tmpl$();
                (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$8, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).gpc);
                return _el$8;
            }
        }), _el$9);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$0, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).modalTitle);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$9, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $44b2e6cc5a4c09f8$export$bdf530073099ce9f), {
            each: (0, $e0c366c0458a196e$export$a513ea61a7bee91c),
            children: (c)=>(0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $b1dc0be175d212eb$export$2e2bcd8739ae039), {
                    category: c,
                    get checked () {
                        return (0, $5ad41d0ab9107ecf$export$7c73462e0d25e514)(()=>c.id === 'analytics')() ? analytics() : (0, $5ad41d0ab9107ecf$export$7c73462e0d25e514)(()=>c.id === 'marketing')() ? marketing() : true;
                    },
                    get onChange () {
                        return c.id === 'analytics' ? setAnalytics : c.id === 'marketing' ? setMarketing : undefined;
                    },
                    get gpcLocked () {
                        return props.gpc && c.id === 'marketing';
                    }
                })
        }), null);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$1, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $28a8adbfaeaa730d$export$2e2bcd8739ae039), {
            get label () {
                return (0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).rejectAll;
            },
            testId: "consent-modal-reject",
            get disabled () {
                return props.busy;
            },
            get onClick () {
                return props.onReject;
            }
        }), null);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$1, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $28a8adbfaeaa730d$export$2e2bcd8739ae039), {
            get label () {
                return (0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).saveChoices;
            },
            testId: "consent-modal-save",
            get disabled () {
                return props.busy;
            },
            onClick: ()=>props.onSave({
                    analytics: analytics(),
                    marketing: marketing() && !props.gpc
                })
        }), null);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$1, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $28a8adbfaeaa730d$export$2e2bcd8739ae039), {
            get label () {
                return (0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).acceptAll;
            },
            testId: "consent-modal-accept",
            get disabled () {
                return props.busy;
            },
            get onClick () {
                return props.onAccept;
            }
        }), null);
        (0, $44b2e6cc5a4c09f8$export$314dade334ae905d)((_p$)=>{
            var _v$ = props.busy ? 'true' : 'false', _v$2 = (0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).closeLabel;
            _v$ !== _p$.e && (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$2, "aria-busy", _p$.e = _v$);
            _v$2 !== _p$.t && (0, $5ad41d0ab9107ecf$export$9fec4d97f1922e0b)(_el$5, "aria-label", _p$.t = _v$2);
            return _p$;
        }, {
            e: undefined,
            t: undefined
        });
        return _el$;
    })();
}



/**
 * Consent configuration. Everything consent-related lives in this folder so it
 * can be copied to main-new-ui (MR !3115) as-is.
 *
 * `templates/_consent_head.html` (inline, runs before any bundle) sets
 * window.TUNE_CONSENT_CONFIG; values there win over these defaults. Keep the
 * IDs / names in sync if you change them.
 */ /**
 * Bump to re-prompt everyone (e.g. new category or tracker). 2 (Nov 5, 2026): final copy +
 * Adobe Fonts moved from Marketing to Strictly necessary, so consents stored under v1 re-prompt.
 */ const $5012381237400dbf$export$9853ccfbed83a967 = 2;
const $5012381237400dbf$export$d5904bbc036c913c = '2026-11-05';
const $5012381237400dbf$export$86880b4b2e1a2384 = 'tune_consent';
const $5012381237400dbf$export$eb80e1beaa8dacf8 = 'tune_consent';
const $5012381237400dbf$export$abcd604640407885 = 'tune_consent_pending';
const $5012381237400dbf$export$911dcfa91cf67d9a = 12;
const $5012381237400dbf$export$80c5899b2c14712a = 365;
const $5012381237400dbf$export$fe900c0eb3b3183d = 'G-6689026RCH';
const $5012381237400dbf$export$1e063e25369382bc = 'GTM-W5LBRNP4';
const $5012381237400dbf$export$7f11627654859d8 = '/api/v1/privacy/consent';
const $5012381237400dbf$export$de6e2122e9b87f2d = 'https://tune.fm/privacy-policy/';
const $5012381237400dbf$export$cf56c8cbf79af0b5 = '/api/v1/privacy/consent/purposes';
const $5012381237400dbf$export$a3b25a1440f49f51 = 'tune:consent-change';
function $5012381237400dbf$export$44487a86467333c3() {
    const w = typeof window !== 'undefined' ? window : {};
    const o = w.TUNE_CONSENT_CONFIG || {};
    return {
        version: o.version ?? $5012381237400dbf$export$9853ccfbed83a967,
        policyVersion: o.policyVersion ?? $5012381237400dbf$export$d5904bbc036c913c,
        storageKey: o.storageKey ?? $5012381237400dbf$export$86880b4b2e1a2384,
        cookieName: o.cookieName ?? $5012381237400dbf$export$eb80e1beaa8dacf8,
        gaId: o.gaId ?? $5012381237400dbf$export$fe900c0eb3b3183d,
        gtmId: o.gtmId ?? $5012381237400dbf$export$1e063e25369382bc,
        enableTags: o.enableTags ?? false,
        apiUrl: o.apiUrl === undefined ? $5012381237400dbf$export$7f11627654859d8 : o.apiUrl,
        maxAgeDays: o.maxAgeDays ?? $5012381237400dbf$export$80c5899b2c14712a,
        privacyUrl: o.privacyUrl ?? $5012381237400dbf$export$de6e2122e9b87f2d
    };
}


/**
 * consent-store: framework-agnostic state, persistence, versioning, event bus,
 * Google Consent Mode v2 signals and GA4/GTM loading. No Solid imports here.
 */ 
const $31f52fee840e8e4c$export$7612eb05b3d917ab = {
    necessary: true,
    analytics: false,
    marketing: false
};
const $31f52fee840e8e4c$export$cc98dd1ca06b998c = {
    necessary: true,
    analytics: true,
    marketing: true
};
const $31f52fee840e8e4c$var$g = (b)=>b ? 'granted' : 'denied';
function $31f52fee840e8e4c$export$affa9a6b69fb09f9(c) {
    return {
        analytics_storage: $31f52fee840e8e4c$var$g(c.analytics),
        functionality_storage: 'granted',
        ad_storage: $31f52fee840e8e4c$var$g(c.marketing),
        ad_user_data: $31f52fee840e8e4c$var$g(c.marketing),
        ad_personalization: $31f52fee840e8e4c$var$g(c.marketing),
        personalization_storage: $31f52fee840e8e4c$var$g(c.marketing),
        security_storage: 'granted'
    };
}
function $31f52fee840e8e4c$export$9f94e14e156921fc() {
    try {
        return typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true;
    } catch  {
        return false;
    }
}
function $31f52fee840e8e4c$export$8ca4be2f150ecde2(s, now = Date.now()) {
    const cfg = (0, $5012381237400dbf$export$44487a86467333c3)();
    if (!s || typeof s !== 'object' || s.v !== cfg.version || !s.choices || typeof s.ts !== 'string' || typeof s.id !== 'string') return false;
    const t = Date.parse(s.ts);
    if (isNaN(t)) return false;
    if (now - t > cfg.maxAgeDays * 864e5) return false;
    return typeof s.choices.analytics === 'boolean' && typeof s.choices.marketing === 'boolean';
}
function $31f52fee840e8e4c$var$readCookie(name) {
    if (typeof document === 'undefined') return null;
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
}
function $31f52fee840e8e4c$export$bfe8d4de028c36cc() {
    const cfg = (0, $5012381237400dbf$export$44487a86467333c3)();
    let raw = null;
    try {
        raw = window.localStorage.getItem(cfg.storageKey);
    } catch  {
    /* storage blocked */ }
    if (!raw) raw = $31f52fee840e8e4c$var$readCookie(cfg.cookieName);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        return $31f52fee840e8e4c$export$8ca4be2f150ecde2(parsed) ? $31f52fee840e8e4c$export$c2fa6ca9e5bbaed4(parsed) : null;
    } catch  {
        return null;
    }
}
function $31f52fee840e8e4c$export$c2fa6ca9e5bbaed4(s) {
    if (!$31f52fee840e8e4c$export$9f94e14e156921fc() || !s.choices.marketing) return s;
    return {
        ...s,
        choices: {
            ...s.choices,
            marketing: false
        },
        gpc: true
    };
}
class $31f52fee840e8e4c$export$7fc1314bc973c9cc extends Error {
    constructor(target, cause){
        super(`tune_consent: could not write the ${target}`), this.target = target, this.cause = cause;
        this.name = 'ConsentWriteError';
    }
}
function $31f52fee840e8e4c$export$e1fec73830f5d063(s) {
    const cfg = (0, $5012381237400dbf$export$44487a86467333c3)();
    const raw = JSON.stringify(s);
    let failed = null;
    try {
        window.localStorage.setItem(cfg.storageKey, raw);
    } catch (e) {
        failed = new $31f52fee840e8e4c$export$7fc1314bc973c9cc('localStorage', e);
    }
    try {
        const secure = location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = `${cfg.cookieName}=${encodeURIComponent(raw)}; Max-Age=${cfg.maxAgeDays * 86400}; Path=/; SameSite=Lax${secure}`;
    } catch (e) {
        failed = failed || new $31f52fee840e8e4c$export$7fc1314bc973c9cc('cookie', e);
    }
    if (failed) throw failed;
}
function $31f52fee840e8e4c$export$b56d3c5cf50da028() {
    const cfg = (0, $5012381237400dbf$export$44487a86467333c3)();
    try {
        window.localStorage.removeItem(cfg.storageKey);
    } catch  {}
    try {
        document.cookie = `${cfg.cookieName}=; Max-Age=0; Path=/`;
    } catch  {}
}
// ---------- gtag / tag loading ----------
function $31f52fee840e8e4c$var$gtag(...args) {
    const w = window;
    w.dataLayer = w.dataLayer || [];
    if (typeof w.gtag === 'function') w.gtag(...args);
    else w.dataLayer.push(arguments);
}
function $31f52fee840e8e4c$export$9c6c34c61f4c28b3(c) {
    $31f52fee840e8e4c$var$gtag('consent', 'update', $31f52fee840e8e4c$export$affa9a6b69fb09f9(c));
}
function $31f52fee840e8e4c$var$injectScript(src, id) {
    if (document.getElementById(id)) return;
    const s = document.createElement('script');
    s.async = true;
    s.src = src;
    s.id = id;
    document.head.appendChild(s);
}
function $31f52fee840e8e4c$export$ddf1689ed7d38b78(c) {
    const cfg = (0, $5012381237400dbf$export$44487a86467333c3)();
    if (!cfg.enableTags || typeof document === 'undefined') return;
    const w = window;
    const state = w.__tuneTags = w.__tuneTags || {
        ga: false,
        gtm: false
    };
    if (c.analytics && !state.ga) {
        state.ga = true;
        $31f52fee840e8e4c$var$injectScript(`https://www.googletagmanager.com/gtag/js?id=${cfg.gaId}`, 'tune-ga4');
        $31f52fee840e8e4c$var$gtag('js', new Date());
        $31f52fee840e8e4c$var$gtag('config', cfg.gaId);
    }
    if ((c.analytics || c.marketing) && !state.gtm) {
        state.gtm = true;
        w.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        $31f52fee840e8e4c$var$injectScript(`https://www.googletagmanager.com/gtm.js?id=${cfg.gtmId}`, 'tune-gtm');
    }
}
const $31f52fee840e8e4c$export$e83d85e1eab8e328 = /^(_ga($|_)|_gid$|_gat($|_)|_dc_gtm_)/;
const $31f52fee840e8e4c$export$57fbc6442bfe08b7 = /^(_gcl_|_gac_|_fbp$|_fbc$|_ttp$|_tt_|_uetsid|_uetvid|_pin_unauth$|_pinterest_|_rdt_|_scid|_sctr$|li_fat_id$|IDE$|test_cookie$)/;
function $31f52fee840e8e4c$export$d5bedd10abbc461b(host = typeof location !== 'undefined' ? location.hostname : '') {
    const out = new Set([
        ''
    ]);
    if (!host) return [
        ''
    ];
    out.add(host);
    const parts = host.split('.');
    for(let i = 0; i < parts.length - 1; i++)out.add('.' + parts.slice(i).join('.'));
    return [
        ...out
    ];
}
function $31f52fee840e8e4c$var$deleteCookiesMatching(re) {
    if (typeof document === 'undefined') return [];
    const removed = [];
    const domains = $31f52fee840e8e4c$export$d5bedd10abbc461b();
    document.cookie.split(';').forEach((p)=>{
        const name = p.split('=')[0].trim();
        if (!name || !re.test(name)) return;
        removed.push(name);
        for (const d of domains)for (const path of [
            '/',
            location.pathname || '/'
        ])document.cookie = `${name}=; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=${path}${d ? '; Domain=' + d : ''}`;
    });
    return removed;
}
function $31f52fee840e8e4c$export$afe11f4826f1b6b() {
    return $31f52fee840e8e4c$var$deleteCookiesMatching($31f52fee840e8e4c$export$e83d85e1eab8e328);
}
function $31f52fee840e8e4c$export$b6dbb2efaca4f062() {
    return $31f52fee840e8e4c$var$deleteCookiesMatching($31f52fee840e8e4c$export$57fbc6442bfe08b7);
}
const $31f52fee840e8e4c$var$listeners = new Set();
let $31f52fee840e8e4c$var$current = null;
function $31f52fee840e8e4c$export$dd4e284306a648e7() {
    return $31f52fee840e8e4c$var$current;
}
function $31f52fee840e8e4c$export$ec068583843480e7(fn) {
    $31f52fee840e8e4c$var$listeners.add(fn);
    return ()=>$31f52fee840e8e4c$var$listeners.delete(fn);
}
function $31f52fee840e8e4c$export$54d2faf86635f4e6() {
    $31f52fee840e8e4c$var$current = $31f52fee840e8e4c$export$bfe8d4de028c36cc(); // GPC already applied (withGpc)
    if ($31f52fee840e8e4c$var$current) {
        if (!$31f52fee840e8e4c$var$current.choices.marketing) $31f52fee840e8e4c$export$b6dbb2efaca4f062();
        $31f52fee840e8e4c$export$9c6c34c61f4c28b3($31f52fee840e8e4c$var$current.choices);
        $31f52fee840e8e4c$export$ddf1689ed7d38b78($31f52fee840e8e4c$var$current.choices);
    }
    return $31f52fee840e8e4c$var$current;
}
function $31f52fee840e8e4c$export$19f53698e68b2496() {
    const c = typeof crypto !== 'undefined' ? crypto : null;
    if (c?.randomUUID) return c.randomUUID();
    const b = new Uint8Array(16);
    if (c?.getRandomValues) c.getRandomValues(b);
    else for(let i = 0; i < 16; i++)b[i] = Math.floor(Math.random() * 256);
    b[6] = b[6] & 0x0f | 0x40;
    b[8] = b[8] & 0x3f | 0x80;
    const h = [
        ...b
    ].map((x)=>x.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
let $31f52fee840e8e4c$export$da22d4a5076a7905 = ()=>{
    try {
        window.location.reload();
    } catch  {}
};
function $31f52fee840e8e4c$export$bf7abda76c506798(fn) {
    $31f52fee840e8e4c$export$da22d4a5076a7905 = fn;
}
const $31f52fee840e8e4c$export$357d1cddbf8a9cf2 = 1200;
function $31f52fee840e8e4c$export$e722781bdea39a0e() {
    const st = typeof window !== 'undefined' ? window.__tuneTags : null;
    return {
        ga: !!st?.ga,
        gtm: !!st?.gtm,
        typekit: !!st?.typekit
    };
}
function $31f52fee840e8e4c$export$bdd8f412f73e68d2(prev, next) {
    if (!prev) return false;
    const t = $31f52fee840e8e4c$export$e722781bdea39a0e();
    const analyticsRevoked = prev.analytics && !next.analytics && (t.ga || t.gtm);
    // Adobe Fonts is strictly necessary (spec §4), so withdrawing marketing never reloads for it.
    const marketingRevoked = prev.marketing && !next.marketing && t.gtm;
    return !!(analyticsRevoked || marketingRevoked);
}
function $31f52fee840e8e4c$export$24a32d9eaac5e08d(choices, action, source, opts = {}) {
    const prev = $31f52fee840e8e4c$var$current;
    const gpc = $31f52fee840e8e4c$export$9f94e14e156921fc();
    // GPC = opt-out of sale/share: marketing can never be granted while it is on,
    // not even by "Accept all" (CCPA regs 7025; !3123 also forces it server-side).
    const c = {
        necessary: true,
        analytics: !!choices.analytics,
        marketing: !!choices.marketing && !gpc
    };
    const cfg = (0, $5012381237400dbf$export$44487a86467333c3)();
    const s = {
        id: prev?.id || $31f52fee840e8e4c$var$readAnyId() || $31f52fee840e8e4c$export$19f53698e68b2496(),
        v: cfg.version,
        pv: cfg.policyVersion,
        ts: new Date().toISOString(),
        choices: c,
        action: $31f52fee840e8e4c$export$8162d088f9bbcedd(action, c, prev),
        source: source,
        gpc: gpc
    };
    const reload = $31f52fee840e8e4c$export$bdd8f412f73e68d2(prev?.choices, c);
    $31f52fee840e8e4c$var$current = s;
    // order: Consent Mode update first, then cookies, then storage, then reload
    $31f52fee840e8e4c$export$9c6c34c61f4c28b3(c);
    if (prev?.choices.analytics && !c.analytics) $31f52fee840e8e4c$export$afe11f4826f1b6b();
    if (!c.marketing) $31f52fee840e8e4c$export$b6dbb2efaca4f062();
    try {
        $31f52fee840e8e4c$export$e1fec73830f5d063(s);
    } catch (e) {
        // Not saved: never report success, load tags, notify, post or reload.
        // Roll the in-memory state back; Consent Mode keeps only what both the old
        // and the new choice allow (a failed grant stays denied, a failed withdrawal
        // stays denied for this page), then the caller shows COPY.saveError.
        $31f52fee840e8e4c$var$current = prev;
        const was = prev?.choices || $31f52fee840e8e4c$export$7612eb05b3d917ab;
        $31f52fee840e8e4c$export$9c6c34c61f4c28b3({
            necessary: true,
            analytics: was.analytics && c.analytics,
            marketing: was.marketing && c.marketing
        });
        throw e;
    }
    if (!reload) $31f52fee840e8e4c$export$ddf1689ed7d38b78(c);
    try {
        window.dataLayer?.push({
            event: 'tune_consent_update',
            tune_consent: c
        });
    } catch  {}
    $31f52fee840e8e4c$var$listeners.forEach((l)=>{
        try {
            l(s);
        } catch  {}
    });
    try {
        window.dispatchEvent(new CustomEvent((0, $5012381237400dbf$export$a3b25a1440f49f51), {
            detail: s
        }));
    } catch  {}
    let posted = Promise.resolve();
    if (opts.post) try {
        posted = Promise.resolve(opts.post(s)).catch(()=>{});
    } catch  {}
    if (reload) // GA4/GTM are already running and cannot be unloaded: reload so they are
    // gone. The receipt is queued before sending (consent-api), so a reload
    // that interrupts it is retried on the next page.
    Promise.race([
        posted,
        new Promise((r)=>setTimeout(r, $31f52fee840e8e4c$export$357d1cddbf8a9cf2))
    ]).then(()=>$31f52fee840e8e4c$export$da22d4a5076a7905());
    return s;
}
function $31f52fee840e8e4c$export$9ab678fe0b13fe2(source, opts = {}) {
    const analytics = !!$31f52fee840e8e4c$var$current?.choices.analytics;
    return $31f52fee840e8e4c$export$24a32d9eaac5e08d({
        analytics: analytics,
        marketing: false
    }, 'customize', source, opts);
}
function $31f52fee840e8e4c$export$8162d088f9bbcedd(requested, c, prev) {
    const none = !c.analytics && !c.marketing;
    if (none) return prev && (prev.choices.analytics || prev.choices.marketing) ? 'withdraw' : 'reject_all';
    if (requested === 'accept_all' && c.analytics && c.marketing) return 'accept_all';
    return 'customize';
}
function $31f52fee840e8e4c$export$72dace353081a6a5(server, source = 'settings_link') {
    const prev = $31f52fee840e8e4c$var$current;
    const s = $31f52fee840e8e4c$export$24a32d9eaac5e08d({
        analytics: server.categories.analytics,
        marketing: server.categories.marketing
    }, server.action === 'accept_all' ? 'accept_all' : server.action === 'customize' ? 'customize' : 'reject_all', source);
    // keep the server's id (it is linked to the account) and its time
    const t = Date.parse(server.received_at);
    const merged = {
        ...s,
        id: server.consent_id || s.id,
        ts: isNaN(t) ? s.ts : new Date(t).toISOString()
    };
    $31f52fee840e8e4c$var$current = merged;
    $31f52fee840e8e4c$export$e1fec73830f5d063(merged);
    return merged;
}
function $31f52fee840e8e4c$export$d80963dee4cdb9ca() {
    return $31f52fee840e8e4c$var$current?.id || $31f52fee840e8e4c$export$bfe8d4de028c36cc()?.id || $31f52fee840e8e4c$var$readAnyId();
}
function $31f52fee840e8e4c$export$1b2e735077b9f23c() {
    const id = $31f52fee840e8e4c$export$d80963dee4cdb9ca();
    return id ? {
        'X-Consent-Id': id
    } : {};
}
/** Keep the consent_id stable even when an old-version record is re-prompted. */ function $31f52fee840e8e4c$var$readAnyId() {
    try {
        const raw = window.localStorage.getItem((0, $5012381237400dbf$export$44487a86467333c3)().storageKey);
        const id = raw && JSON.parse(raw)?.id;
        return typeof id === 'string' ? id : null;
    } catch  {
        return null;
    }
}
function $31f52fee840e8e4c$export$f5319931f716bf98() {
    const s = $31f52fee840e8e4c$var$current;
    if (s) return {
        ...s.choices
    };
    return {
        ...$31f52fee840e8e4c$export$7612eb05b3d917ab
    };
}
function $31f52fee840e8e4c$export$472c62b7703c58cb() {
    $31f52fee840e8e4c$var$current = null;
    $31f52fee840e8e4c$var$listeners.clear();
}


var $db851154493d318f$var$_tmpl$ = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<span data-testid=consent-saved class="block rounded-lg border border-[color:var(--tc-border)] bg-[var(--tc-surface-overlay)] px-4 py-2 text-[13px] text-[color:var(--tc-success)]">`), $db851154493d318f$var$_tmpl$2 = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<span data-testid=consent-save-error class="block rounded-lg border border-[color:var(--tc-border)] bg-[var(--tc-surface-overlay)] px-4 py-2 text-[13px] text-[color:var(--tc-error,#ff688a)]">`), $db851154493d318f$var$_tmpl$3 = /*#__PURE__*/ (0, $5ad41d0ab9107ecf$export$ce69bd05624d0c48)(`<div class=tc-root><div role=status aria-live=polite aria-atomic=true data-testid=consent-status class="tc-bottom fixed left-1/2 -translate-x-1/2">`);
function $db851154493d318f$export$2e2bcd8739ae039(props) {
    const gpc = (0, $31f52fee840e8e4c$export$9f94e14e156921fc)();
    const [banner, setBanner] = (0, $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5)(props.initiallyOpen);
    const [modal, setModal] = (0, $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5)(false);
    const [modalSource, setModalSource] = (0, $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5)('preferences_modal');
    const [busy, setBusy] = (0, $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5)(false);
    const [notice, setNotice] = (0, $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5)(false);
    const [saveError, setSaveError] = (0, $44b2e6cc5a4c09f8$export$c1e1e1ecbbe76a5)(false);
    let returnFocus = null;
    let timer;
    const openModal = (source, trigger)=>{
        // Trigger = the element that opened the modal: a page link (light DOM) or
        // the banner's Customize button (shadow DOM). Focus goes back to it on close.
        returnFocus = trigger || props.root.activeElement || null;
        setModalSource(source);
        setModal(true);
    };
    props.registerOpen((source = 'settings_link', trigger)=>openModal(source, trigger));
    /** Return focus to the trigger; if it is gone (banner Customize unmounted) use the banner's Customize button, then the page body. */ const restoreFocus = ()=>{
        const el = returnFocus;
        returnFocus = null;
        if (el && el.isConnected && typeof el.focus === 'function') {
            // icon-only triggers (e.g. the sidebar <i> menu button) are not natively focusable
            if (!el.matches('a[href],button,input,select,textarea,summary,[tabindex]')) el.setAttribute('tabindex', '-1');
            return el.focus();
        }
        const customize = props.root.querySelector?.('[data-testid="consent-customize"]');
        if (customize) return customize.focus();
    };
    const closeModal = ()=>{
        setModal(false);
        // wait for Solid to re-render the banner (if it comes back) before focusing
        queueMicrotask(restoreFocus);
    };
    /** Run a save; on success hide the banner/modal and show COPY.saved, on failure keep them open and show COPY.saveError. */ const run = (save)=>{
        setBusy(true);
        setSaveError(false);
        setNotice(false);
        try {
            save();
        } catch  {
            // storage write failed (ConsentWriteError) or anything unexpected:
            // keep the banner/modal open so the visitor can try again
            setSaveError(true);
            return false;
        } finally{
            setBusy(false);
        }
        setBanner(false);
        if (modal()) closeModal();
        setNotice(true);
        clearTimeout(timer);
        timer = setTimeout(()=>setNotice(false), 4000);
        return true;
    };
    const commit = (c, action, source)=>run(()=>(0, $31f52fee840e8e4c$export$24a32d9eaac5e08d)(c, action, source, {
                post: props.onSave
            }));
    /** CCPA "Do Not Sell or Share": marketing off (GPC withdrawal path), analytics unchanged. */ const doNotSell = (source = 'settings_link')=>run(()=>(0, $31f52fee840e8e4c$export$9ab678fe0b13fe2)(source, {
                post: props.onSave
            }));
    props.registerDoNotSell?.(doNotSell);
    (0, $44b2e6cc5a4c09f8$export$b36e5eaa3e8c43ab)(()=>clearTimeout(timer));
    const initial = ()=>{
        const s = (0, $31f52fee840e8e4c$export$dd4e284306a648e7)();
        return s ? {
            analytics: s.choices.analytics,
            marketing: s.choices.marketing
        } : {
            analytics: false,
            marketing: false
        };
    };
    return (()=>{
        var _el$ = $db851154493d318f$var$_tmpl$3(), _el$2 = _el$.firstChild;
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $44b2e6cc5a4c09f8$export$f6a3d19be20f5819), {
            get when () {
                return (0, $5ad41d0ab9107ecf$export$7c73462e0d25e514)(()=>!!banner())() && !modal();
            },
            get children () {
                return (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $df74a03f26d92cab$export$2e2bcd8739ae039), {
                    gpc: gpc,
                    get busy () {
                        return busy();
                    },
                    get privacyUrl () {
                        return (0, $5012381237400dbf$export$44487a86467333c3)().privacyUrl;
                    },
                    onReject: ()=>commit({
                            analytics: false,
                            marketing: false
                        }, 'reject_all', 'banner'),
                    onCustomize: (e)=>openModal('preferences_modal', e?.currentTarget || null),
                    onAccept: ()=>commit({
                            analytics: true,
                            marketing: true
                        }, 'accept_all', 'banner'),
                    onDoNotSell: ()=>doNotSell('banner')
                });
            }
        }), _el$2);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $44b2e6cc5a4c09f8$export$f6a3d19be20f5819), {
            get when () {
                return modal();
            },
            get children () {
                return (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $56183baabcc2a64f$export$2e2bcd8739ae039), {
                    get initial () {
                        return initial();
                    },
                    gpc: gpc,
                    get busy () {
                        return busy();
                    },
                    get root () {
                        return props.root;
                    },
                    onClose: closeModal,
                    onReject: ()=>commit({
                            analytics: false,
                            marketing: false
                        }, 'reject_all', modalSource()),
                    onSave: (c)=>commit(c, 'customize', modalSource()),
                    onAccept: ()=>commit({
                            analytics: true,
                            marketing: true
                        }, 'accept_all', modalSource())
                });
            }
        }), _el$2);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$2, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $44b2e6cc5a4c09f8$export$f6a3d19be20f5819), {
            get when () {
                return notice();
            },
            get children () {
                var _el$3 = $db851154493d318f$var$_tmpl$();
                (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$3, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).saved);
                return _el$3;
            }
        }), null);
        (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$2, (0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $44b2e6cc5a4c09f8$export$f6a3d19be20f5819), {
            get when () {
                return saveError();
            },
            get children () {
                var _el$4 = $db851154493d318f$var$_tmpl$2();
                (0, $5ad41d0ab9107ecf$export$21a5ca8aa77d35ff)(_el$4, ()=>(0, $e0c366c0458a196e$export$92f9e1ed9114d3a6).saveError);
                return _el$4;
            }
        }), null);
        return _el$;
    })();
}



/**
 * Server-side consent log: BackendBot MR !3123 (branch feature/gdpr-ccpa-privacy,
 * django_app/privacy/consent_api.py `ConsentEventView`, serializers.py
 * `ConsentEventSerializer`). Fire-and-forget, never throws, never blocks the UI,
 * never turns a failure into consent.
 *
 *   GET  /api/v1/privacy/consent   (?consent_id= or X-Consent-Id; or the signed-in user)
 *        -> 200 { current: null | { id, consent_id, categories, action,
 *                                   consent_version, policy_version, received_at } }
 *        Also sets the csrftoken cookie (ensure_csrf_cookie).
 *   POST /api/v1/privacy/consent   AllowAny (anonymous OK), CSRF enforced for every caller
 *        body = ConsentApiPayload below, exactly the serializer fields
 *        -> 201 { id, received_at } | 400 field errors (never retried)
 *        | 429 (30/min anon, 60/min user) + Retry-After (respected)
 *        | 403/404/405/5xx/network -> queued, exponential backoff, max 6 attempts
 *   Serializer rules: categories {necessary:true, analytics, marketing} strict
 *   booleans, no extra keys; accept_all => both true; reject_all/withdraw =>
 *   both false; page = path only; locale BCP-47-ish; gpc strict bool; with GPC
 *   marketing is stored false. The server derives sale_share/targeted_ads.
 *
 * Anonymous visitors: the choice is kept in localStorage/cookie and also posted
 * anonymously (the endpoint allows it) under consent_id. After login,
 * syncConsentAfterLogin() reads the server state and merges it (see below).
 */ 

const $c00f9cd44fcbd034$var$LOCALE_RE = /^[A-Za-z]{2,3}([-_][A-Za-z0-9]{2,8})*$/;
function $c00f9cd44fcbd034$export$3f314a4a690d76c7() {
    const cands = [
        typeof document !== 'undefined' ? document.documentElement.lang : '',
        typeof navigator !== 'undefined' ? navigator.language : ''
    ];
    for (const c of cands)if (c && $c00f9cd44fcbd034$var$LOCALE_RE.test(c)) return c;
    return 'en';
}
function $c00f9cd44fcbd034$export$200c619e846540a2(s) {
    return {
        consent_id: s.id,
        categories: {
            necessary: true,
            analytics: s.choices.analytics,
            marketing: s.choices.marketing
        },
        action: s.action,
        consent_version: s.v,
        policy_version: s.pv,
        timestamp: s.ts,
        source: s.source,
        page: typeof location !== 'undefined' && location.pathname || '/',
        locale: $c00f9cd44fcbd034$export$3f314a4a690d76c7(),
        gpc: s.gpc
    };
}
const $c00f9cd44fcbd034$export$da9ab7b2fd5998e8 = 6;
function $c00f9cd44fcbd034$var$readPending() {
    try {
        return JSON.parse(localStorage.getItem((0, $5012381237400dbf$export$abcd604640407885)) || 'null');
    } catch  {
        return null;
    }
}
function $c00f9cd44fcbd034$var$writePending(p) {
    try {
        if (p) localStorage.setItem((0, $5012381237400dbf$export$abcd604640407885), JSON.stringify(p));
        else localStorage.removeItem((0, $5012381237400dbf$export$abcd604640407885));
    } catch  {}
}
function $c00f9cd44fcbd034$export$ec5f0fa50cda4eeb() {
    if (typeof document === 'undefined') return null;
    const m = document.cookie.match(/(?:^|; )csrftoken=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : null;
}
async function $c00f9cd44fcbd034$export$84e83902d3a16987(apiUrl) {
    let t = $c00f9cd44fcbd034$export$ec5f0fa50cda4eeb();
    if (t) return t;
    try {
        await fetch(apiUrl, {
            method: 'GET',
            credentials: 'same-origin'
        });
    } catch  {}
    t = $c00f9cd44fcbd034$export$ec5f0fa50cda4eeb();
    return t || (typeof window !== 'undefined' ? window.csrfTOKEN || null : null);
}
function $c00f9cd44fcbd034$export$230ef8da5847c5b1(v, now = Date.now()) {
    if (!v) return null;
    const n = Number(v);
    if (Number.isFinite(n)) return now + Math.max(0, n) * 1000;
    const d = Date.parse(v);
    return isNaN(d) ? null : d;
}
async function $c00f9cd44fcbd034$var$send(payload, extraHeaders = {}) {
    const { apiUrl: apiUrl } = (0, $5012381237400dbf$export$44487a86467333c3)();
    if (!apiUrl || typeof fetch !== 'function') return {
        ok: false
    };
    try {
        const csrf = await $c00f9cd44fcbd034$export$84e83902d3a16987(apiUrl);
        const headers = {
            'Content-Type': 'application/json',
            'X-Consent-Id': payload.consent_id,
            ...extraHeaders
        };
        if (csrf) headers['X-CSRFToken'] = csrf;
        const res = await fetch(apiUrl, {
            method: 'POST',
            headers: headers,
            credentials: 'same-origin',
            body: JSON.stringify(payload),
            keepalive: true
        });
        let body = null;
        try {
            body = await res.json();
        } catch  {}
        if (res.ok) return {
            ok: true,
            status: res.status,
            id: body?.id,
            received_at: body?.received_at
        };
        if (res.status === 400) return {
            ok: false,
            status: 400,
            errors: body || {}
        };
        if (res.status === 429) return {
            ok: false,
            status: 429,
            retryAt: $c00f9cd44fcbd034$export$230ef8da5847c5b1(res.headers?.get?.('Retry-After'))
        };
        return {
            ok: false,
            status: res.status
        };
    } catch  {
        return {
            ok: false
        };
    }
}
function $c00f9cd44fcbd034$var$handleFailure(payload, attempts, r) {
    // 400 = our payload is invalid; retrying would just repeat it.
    if (r.status === 400 || attempts >= $c00f9cd44fcbd034$export$da9ab7b2fd5998e8) return $c00f9cd44fcbd034$var$writePending(null);
    const backoff = Date.now() + 60000 * 2 ** (attempts - 1); // 1, 2, 4, 8, 16 min
    $c00f9cd44fcbd034$var$writePending({
        payload: payload,
        attempts: attempts,
        next: Math.max(backoff, r.retryAt || 0)
    });
}
async function $c00f9cd44fcbd034$export$8881e1511bac9b2b(s, extraHeaders) {
    if (!(0, $5012381237400dbf$export$44487a86467333c3)().apiUrl) return {
        ok: false
    };
    const payload = $c00f9cd44fcbd034$export$200c619e846540a2(s);
    // Queue first: if the page reloads (withdrawal) or closes mid-request, the
    // receipt is retried on the next page load.
    $c00f9cd44fcbd034$var$writePending({
        payload: payload,
        attempts: 0,
        next: 0
    });
    const r = await $c00f9cd44fcbd034$var$send(payload, extraHeaders);
    if (r.ok) $c00f9cd44fcbd034$var$writePending(null);
    else $c00f9cd44fcbd034$var$handleFailure(payload, 1, r);
    const { retryAt: retryAt, ...out } = r;
    return out;
}
async function $c00f9cd44fcbd034$export$56a18685af7c6012(now = Date.now()) {
    const p = $c00f9cd44fcbd034$var$readPending();
    if (!p || !(0, $5012381237400dbf$export$44487a86467333c3)().apiUrl || now < p.next) return false;
    const r = await $c00f9cd44fcbd034$var$send(p.payload);
    if (r.ok) $c00f9cd44fcbd034$var$writePending(null);
    else $c00f9cd44fcbd034$var$handleFailure(p.payload, p.attempts + 1, r);
    return r.ok;
}
async function $c00f9cd44fcbd034$export$5d1841c4aa6b389a(authHeaders = {}) {
    const { apiUrl: apiUrl } = (0, $5012381237400dbf$export$44487a86467333c3)();
    if (!apiUrl || typeof fetch !== 'function') return null;
    try {
        const id = (0, $31f52fee840e8e4c$export$d80963dee4cdb9ca)();
        const res = await fetch(apiUrl, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                ...id ? {
                    'X-Consent-Id': id
                } : {},
                ...authHeaders
            }
        });
        if (!res.ok) return null;
        const body = await res.json();
        return body?.current ?? null;
    } catch  {
        return null;
    }
}
async function $c00f9cd44fcbd034$export$a9d7a78897ccdc97(authHeaders = {}) {
    try {
        const local = (0, $31f52fee840e8e4c$export$dd4e284306a648e7)() || (0, $31f52fee840e8e4c$export$bfe8d4de028c36cc)();
        const server = await $c00f9cd44fcbd034$export$5d1841c4aa6b389a(authHeaders);
        const cfg = (0, $5012381237400dbf$export$44487a86467333c3)();
        const serverUsable = !!server && server.consent_version === cfg.version;
        if (!serverUsable) {
            if (!local) return 'none';
            const r = await $c00f9cd44fcbd034$export$8881e1511bac9b2b(local, authHeaders);
            return r.ok ? 'pushed_local' : 'error';
        }
        const sTime = Date.parse(server.received_at);
        const same = !!local && local.choices.analytics === server.categories.analytics && local.choices.marketing === server.categories.marketing;
        if (same) return 'in_sync';
        if (!local || !isNaN(sTime) && sTime > Date.parse(local.ts)) {
            (0, $31f52fee840e8e4c$export$72dace353081a6a5)(server);
            return 'adopted_server';
        }
        const r = await $c00f9cd44fcbd034$export$8881e1511bac9b2b(local, authHeaders);
        return r.ok ? 'pushed_local' : 'error';
    } catch  {
        return 'error';
    }
}


/**
 * YouTube without pre-consent requests.
 *
 * - Embeds: markup `<div data-tune-yt="VIDEO_ID" data-tune-yt-title="...">`
 *   with a <button data-tune-yt-play> inside. Nothing loads from YouTube
 *   until the visitor clicks Play (then it autoplays) or has granted
 *   marketing consent. The iframe uses www.youtube-nocookie.com.
 * - Thumbnails (SPA galleries): youtubeThumbUrl() returns the i.ytimg.com URL
 *   only with marketing consent, otherwise a local inline placeholder, so the
 *   page makes no request to YouTube/Google before consent.
 */ 

const $c97cb23f6fb154b6$var$ID_RE = /^[\w-]{11}$/;
function $c97cb23f6fb154b6$export$8406429bdf9f6c30(id, autoplay = false) {
    const q = new URLSearchParams({
        rel: '0',
        controls: '1',
        autoplay: autoplay ? '1' : '0',
        mute: '0',
        start: '0'
    });
    return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?${q}`;
}
const $c97cb23f6fb154b6$export$5a07dd4d8268a586 = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 360"><rect width="480" height="360" fill="#16161d"/><circle cx="240" cy="180" r="44" fill="#7c3aed"/><path d="M226 158v44l36-22z" fill="#fff"/></svg>');
function $c97cb23f6fb154b6$var$marketingGranted() {
    return (0, $31f52fee840e8e4c$export$bfe8d4de028c36cc)()?.choices.marketing === true;
}
function $c97cb23f6fb154b6$export$eca667a1dff579e7(id, quality = 'hqdefault') {
    if (!id || !$c97cb23f6fb154b6$var$ID_RE.test(id) || !$c97cb23f6fb154b6$var$marketingGranted()) return $c97cb23f6fb154b6$export$5a07dd4d8268a586;
    return `https://i.ytimg.com/vi/${id}/${quality}.jpg`;
}
function $c97cb23f6fb154b6$export$e699215886058999(el, autoplay) {
    if (el.dataset.tuneYtLoaded === '1') return el.querySelector('iframe');
    const id = el.dataset.tuneYt || '';
    if (!$c97cb23f6fb154b6$var$ID_RE.test(id)) return null;
    const f = document.createElement('iframe');
    f.src = $c97cb23f6fb154b6$export$8406429bdf9f6c30(id, autoplay);
    f.title = el.dataset.tuneYtTitle || 'YouTube video';
    f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    f.setAttribute('frameborder', '0');
    f.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;border:0';
    const slot = el.querySelector('[data-tune-yt-slot]') || el;
    slot.querySelector('[data-tune-yt-play]')?.remove();
    slot.appendChild(f);
    el.dataset.tuneYtLoaded = '1';
    if (autoplay) f.focus?.();
    return f;
}
function $c97cb23f6fb154b6$export$8bddacc957c5b2dd(root = document) {
    const all = ()=>[
            ...root.querySelectorAll('[data-tune-yt]')
        ];
    for (const el of all()){
        if (el.dataset.tuneYtWired === '1') continue;
        el.dataset.tuneYtWired = '1';
        el.querySelector('[data-tune-yt-play]')?.addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            $c97cb23f6fb154b6$export$e699215886058999(el, true);
        });
    }
    const maybeAll = ()=>{
        if ($c97cb23f6fb154b6$var$marketingGranted()) all().forEach((el)=>$c97cb23f6fb154b6$export$e699215886058999(el, false));
    };
    maybeAll();
    if (typeof window !== 'undefined' && !window.__tuneYtListening) {
        window.__tuneYtListening = true;
        window.addEventListener((0, $5012381237400dbf$export$a3b25a1440f49f51), maybeAll);
    }
}


function $1431337f45c684ee$export$3574cd882b0d4fe7(opts = {}) {
    if (window.TuneConsent) return window.TuneConsent;
    const stored = (0, $31f52fee840e8e4c$export$54d2faf86635f4e6)();
    if (opts.postToServer !== false) (0, $c00f9cd44fcbd034$export$56a18685af7c6012)().catch(()=>{});
    const host = document.createElement('div');
    host.id = 'tune-consent-root';
    document.body.appendChild(host);
    const shadow = host.attachShadow({
        mode: 'open'
    });
    if (opts.css) {
        const style = document.createElement('style');
        style.textContent = opts.css;
        shadow.appendChild(style);
    }
    const container = document.createElement('div');
    shadow.appendChild(container);
    let openFn = ()=>{};
    let doNotSellFn = ()=>false;
    (0, $5ad41d0ab9107ecf$export$b3890eb0ae9dca99)(()=>(0, $44b2e6cc5a4c09f8$export$60e54eaca7e7fb38)((0, $db851154493d318f$export$2e2bcd8739ae039), {
            root: shadow,
            initiallyOpen: !stored,
            get onSave () {
                return opts.postToServer === false ? undefined : (0, $c00f9cd44fcbd034$export$8881e1511bac9b2b);
            },
            registerOpen: (f)=>openFn = f,
            registerDoNotSell: (f)=>doNotSellFn = f
        }), container);
    const api = {
        open: (s, trigger)=>openFn(s, trigger ?? (document.activeElement !== document.body ? document.activeElement : null)),
        doNotSell: (s = 'settings_link')=>doNotSellFn(s),
        syncAfterLogin: (h)=>(0, $c00f9cd44fcbd034$export$a9d7a78897ccdc97)(h),
        get: (0, $31f52fee840e8e4c$export$dd4e284306a648e7),
        getConsentId: $31f52fee840e8e4c$export$d80963dee4cdb9ca,
        onChange: (0, $31f52fee840e8e4c$export$ec068583843480e7),
        reset: ()=>{
            (0, $31f52fee840e8e4c$export$b56d3c5cf50da028)();
            (0, $31f52fee840e8e4c$export$da22d4a5076a7905)();
        }
    };
    window.TuneConsent = api;
    window.tuneConsent = api;
    // Any element with data-tune-consent-open (footer "Cookie settings" links) opens the modal;
    // data-tune-consent-dns (footer "Do Not Sell or Share" links) sets marketing off.
    document.addEventListener('click', (e)=>{
        const el = e.target;
        const t = el?.closest?.('[data-tune-consent-open]');
        if (t) {
            e.preventDefault();
            api.open('settings_link', t);
            return;
        }
        const d = el?.closest?.('[data-tune-consent-dns]');
        if (d) {
            e.preventDefault();
            api.doNotSell('settings_link');
        }
    });
    (0, $c97cb23f6fb154b6$export$8bddacc957c5b2dd)(document);
    return api;
}


var $8665528fde84fd37$exports = {};
$8665528fde84fd37$exports = ".sr-only{clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.fixed{position:fixed}.sticky{position:sticky}.inset-0{inset:0}.inset-x-0{left:0;right:0}.bottom-0{bottom:0}.left-1\\/2{left:50%}.m-0{margin:0}.mx-auto{margin-left:auto;margin-right:auto}.mb-2{margin-bottom:.5rem}.ml-1{margin-left:.25rem}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.block{display:block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.grid{display:grid}.h-\\[44px\\]{height:44px}.min-h-\\[44px\\]{min-height:44px}.w-\\[44px\\]{width:44px}.w-full{width:100%}.min-w-0{min-width:0}.max-w-\\[1200px\\]{max-width:1200px}.flex-1{flex:1}.-translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.flex-col{flex-direction:column}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-2{gap:.5rem}.gap-4{gap:1rem}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.break-all{word-break:break-all}.rounded-lg{border-radius:.5rem}.rounded-xl{border-radius:.75rem}.border{border-width:1px}.border-0{border-width:0}.border-t{border-top-width:1px}.border-\\[color\\:var\\(--tc-border\\)\\]{border-color:var(--tc-border)}.border-\\[color\\:var\\(--tc-border-soft\\)\\]{border-color:var(--tc-border-soft)}.bg-\\[var\\(--tc-surface\\)\\]{background-color:var(--tc-surface)}.bg-\\[var\\(--tc-surface-overlay\\)\\]{background-color:var(--tc-surface-overlay)}.bg-black\\/60{background-color:#0009}.p-0{padding:0}.p-4{padding:1rem}.px-4{padding-left:1rem;padding-right:1rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.pr-3{padding-right:.75rem}.pt-4{padding-top:1rem}.text-left{text-align:left}.text-\\[12px\\]{font-size:12px}.text-\\[13px\\]{font-size:13px}.text-\\[14px\\]{font-size:14px}.text-base{font-size:1rem;line-height:1.5rem}.text-sm{font-size:.875rem;line-height:1.25rem}.font-medium{font-weight:500}.font-semibold{font-weight:600}.text-\\[color\\:var\\(--tc-accent\\)\\]{color:var(--tc-accent)}.text-\\[color\\:var\\(--tc-error\\,\\#ff688a\\)\\]{color:var(--tc-error,#ff688a)}.text-\\[color\\:var\\(--tc-success\\)\\]{color:var(--tc-success)}.text-\\[color\\:var\\(--tc-text\\)\\]{color:var(--tc-text)}.text-\\[color\\:var\\(--tc-text-2\\)\\]{color:var(--tc-text-2)}.underline{text-decoration-line:underline}.opacity-70{opacity:.7}.shadow{--tw-shadow:0 1px 3px 0 #0000001a, 0 1px 2px -1px #0000001a;--tw-shadow-colored:0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.shadow-2xl{--tw-shadow:0 25px 50px -12px #00000040;--tw-shadow-colored:0 25px 50px -12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.outline-none{outline-offset:2px;outline:2px solid #0000}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}:host{--tc-primary:#8b35df;--tc-primary-hover:#9841e5;--tc-accent:#b78aff;--tc-surface:#121a29;--tc-surface-overlay:#172033;--tc-surface-inset:#080d17;--tc-border-soft:#b0c1e017;--tc-border:#c3d2ee40;--tc-text:#f7f9ff;--tc-text-2:#b7c0d2;--tc-focus:#b78aff;--tc-error:#ff688a;--tc-success:#3adfa1;all:initial;font-family:Roc_Grotesk_Regular,system-ui,sans-serif;line-height:1.4}*,:before,:after{box-sizing:border-box}.tc-root{font-family:Roc_Grotesk_Regular,system-ui,sans-serif}.tc-bottom{z-index:9000;bottom:calc(var(--tc-bottom-offset,0px) + max(1rem, env(safe-area-inset-bottom)))}.tc-modal-layer{z-index:9001}.app-button.app-button--secondary{background:var(--tc-surface);border-color:var(--tc-border);color:var(--tc-text);cursor:pointer;border-style:solid;font-family:inherit;transition:background-color .15s,border-color .15s}.app-button.app-button--secondary:hover{background:var(--tc-surface-overlay);border-color:var(--tc-accent)}.app-button.app-button--secondary:active{background:var(--tc-surface-inset)}.app-button.app-button--secondary:disabled{opacity:.5;cursor:not-allowed}.app-button:focus-visible,.tc-close:focus-visible,.tc-switch:focus-visible,a:focus-visible,summary:focus-visible{outline:2px solid var(--tc-focus);outline-offset:2px}.tc-close{cursor:pointer;background:0 0;border:0}.tc-close:hover{color:var(--tc-text)}.tc-switch{appearance:none;background:var(--tc-surface-inset);border:1px solid var(--tc-border);border-radius:999px;flex-shrink:0;width:44px;height:24px;margin:0;position:relative}.tc-switch:after{content:\"\";background:var(--tc-text-2);border-radius:999px;width:18px;height:18px;position:absolute;top:2px;left:2px}.tc-switch:checked{background:var(--tc-primary);border-color:var(--tc-primary)}.tc-switch:checked:after{background:#fff;left:22px}.tc-switch:hover:not(:disabled){border-color:var(--tc-accent)}.sr-only{clip:rect(0,0,0,0);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}@media (prefers-reduced-motion:reduce){*{transition:none!important;animation:none!important}}@media (width>=640px){.sm\\:relative{position:relative}.sm\\:inset-auto{inset:auto}.sm\\:max-h-\\[85vh\\]{max-height:85vh}.sm\\:w-auto{width:auto}.sm\\:w-full{width:100%}.sm\\:min-w-\\[140px\\]{min-width:140px}.sm\\:max-w-\\[560px\\]{max-width:560px}.sm\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.sm\\:flex-row{flex-direction:row}.sm\\:items-center{align-items:center}.sm\\:gap-3{gap:.75rem}.sm\\:rounded-xl{border-radius:.75rem}.sm\\:border{border-width:1px}.sm\\:border-\\[color\\:var\\(--tc-border\\)\\]{border-color:var(--tc-border)}}@media (width>=768px){.md\\:p-5{padding:1.25rem}.md\\:px-5{padding-left:1.25rem;padding-right:1.25rem}.md\\:px-6{padding-left:1.5rem;padding-right:1.5rem}}@media (width>=1024px){.lg\\:shrink-0{flex-shrink:0}.lg\\:flex-row{flex-direction:row}.lg\\:items-center{align-items:center}.lg\\:justify-between{justify-content:space-between}}";


const $56a293a05826460a$var$css = typeof $8665528fde84fd37$exports === 'string' ? $8665528fde84fd37$exports : $8665528fde84fd37$exports.default;
const $56a293a05826460a$var$start = ()=>(0, $1431337f45c684ee$export$3574cd882b0d4fe7)({
        css: $56a293a05826460a$var$css
    });
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $56a293a05826460a$var$start);
else $56a293a05826460a$var$start();

})();
//# sourceMappingURL=tune-consent.js.map
